import {dispatch, getStore} from 'od-modules/secure_store/store';
import localforage from 'localforage';
import {getShoppingCartFromDAPI, getMembershipSubscriptionDetails} from 'od-modules/secure_store/reducers/asyncActionCreators';
const membershipService = import('od-modules/secure_store/services/MembershipService');
const {fareRulesManager} = require('od-modules/fare_rules_manager');
const {loadAtolWidgets} = require('components/atol_protected/js/main');
const actions = require('../modules/secure_store/actions');
const trackingUtils = require('../modules/utils/tracking.utils');
const tagManagement = require('../modules/utils/tag_management.utils');
const {setTabFocusEvent} = require('../modules/utils/tab_manager/dp_shopping_cart_validation');
const sessionManagement = require('../modules/utils/session.utils');
const emailSuggestion = require('../modules/utils/email_suggestion');
const handlerUtils = require('../modules/handlers/passengerspage');
const buyerUtils = require('../modules/handlers/buyer');
const xsellUtils = require('od-modules/xsell/utils');
const stickySeatsLeftUtils = require('../modules/sticky_seats_left/utils');
const waitingHelper = require('../modules/helpers/waiting');
const notificationsService = require('../modules/utils/notifications').notificationService();
const baggageTracking = require('../tracking/bags_and_seats/baggage_tracking').getInstance();
const seatsTracking = require('../tracking/bags_and_seats/seats_tracking').getInstance();
const priceManagerCollection = require('../modules/collections/pricemanager.collection').getInstance();
const isUserDTOMember = require('../modules/helpers/user.js').isUserDTOMember;
const trackingAncillariesContinuance = require('../tracking/ancillaries_continuance');
const boardingOptionsCollection = require('../modules/collections/boarding_options/boarding_options.collection').getInstance({load: true});
const seatMapSelectionCollection = require('../modules/collections/seatmap_preferences_selections.collection').getInstance();
const loginFactory = require('components/user_area/login/js/main');
const myExpensiveRepricingManagerFactory = require('components/repricing/expensive_repricing_manager/js/main');
const myCheapRepricingManagerFactory = require('components/repricing/cheap_repricing_manager/js/main');
const aircraftmapManagerFactory = require('components/bags_and_seats/aircraftmap_manager/js/main');
const residentNagFactory = require('components/membership/membership_resident_nag/js/main');
const fareFamiliesFactory = require('components/fare_family/fare_family_component/js/main');
const membershipRenewalFactory = require('components/membership/membership_renewal/js/main');
const cartDebuggerFactory = require('components/cart_debugger/js/main');
const membershipPerksLightbox = require('components/membership/membership_perks_info_lightbox/js/main');
const createWidgetLoader = require('components-framework/widget/create_widget_loader');
const ancillariesGeneric = require('../modules/handlers/ancillaries').default;
const membershipSubscriptionErrorFactory = require('components/membership/membership_subscription_error/js/main');
const ancillariesSummaryFactory = require('components/ancillaries_summary/js/main');
const residentDiscountFactory = require('components/resident_discount/js/main').default;
const freeCancellationFactory = require('components/free_cancellation/js/main');
const detailsTotalPriceCalculator = require('od-modules/helpers/price/details.total.price.calculator');
const ShoppingCart = require('od-modules/cart/cart');
const websiteConfigCollection = require('od-modules/collections/website.collection').getInstance();
const logger = require('od-modules/utils/logger');
const sidebarFactory = () => Odigeo.AB.sidebarRevamp || Odigeo.AB.isSidebarPriceBreakdown || Odigeo.AB.isSidebarPriceBreakdownMeta
    ? import(/* webpackChunkName: "sidebar-factory" */ 'components/sidebar/sidebar_root/js/main')
        .then(({default: factory}) => factory)
    : null;
const PAGE = 'details';
const {commonDpResultsUtils} = require('od-modules/handlers/dpresults/common.desktop');
const Dynpack = require('od-apps/app.dynpack');
const errorsEventController = require('od-modules/handlers/dpresults/desktop/errors_event_controller');
const dynpackSearchSecureController = require('od-modules/handlers/dpresults/desktop/search_secure_event_controller');
const vinFlightsTracking = require('../tracking/vin_tracking');
const ancillaries = require('components/bags_and_seats/ancillaries/js/main');
const baggageFactory = require('components/bags_and_seats/baggage/baggage_wrapper/js/main');
const fareRulesFactory = require('components/fare_rules/js/main');
const PBD_MODE = 'PRODUCT_PAGE';
const {isMembershipStatusActivated} = require('od-modules/utils/membership_utils');
const frontendShell = require('od-modules/frontend-shell');
const {trackClickEvent} = require('od-modules/track_events/track.frontevents.utils');

const CONS = {
    INTENTION_TO_BUY_SEATS: 'intentionToBuy_seats',
    INTENTION_TO_BUY_BAGS: 'intentionToBuy_bags',
    NUM_SELECTED_SEATS: 'numSelected_seats',
    UNL_MEMBERSHIP_ALREADY_MEMBER: 'UNL_MEMBERSHIP_ALREADY_MEMBER',
    OFFER_TYPES: {
        FULL_FARE: 'no-prime',
        PRIME_FARE: 'prime',
    },
    TRACKING: {
        CATEGORY: 'flights_pax_page',
        ACTIONS: {
            PRIME: 'prime',
        },
    },
    PAGE: 'pax',
};

const getC4AR = () => Odigeo._.find(priceManagerCollection.getJSONData().items, {'conceptKey': 'CANXSELF'});

Odigeo.SessionScope.totalPriceOfShame = {
    'totalPrice': 0,
    'totalPricePerPax': 0,
};

Odigeo.Router.handlers.details = function(deeplink) {
    resetPrimeSubscription();
    dispatch(getShoppingCartFromDAPI);
    dispatch(getMembershipSubscriptionDetails);
    setDPPricingUtils();
    Odigeo.Session.remove('confirmInteractionNeededData');
    const repricingMAPI = Odigeo.Utils.parseJson(Odigeo.Session.get('repricingMAPI'));
    const isDynpack = Odigeo.Utils.isRequestApp('dp') || Odigeo.Utils.isRequestApp('dynpack');
    const isMktPortal = Odigeo.SessionScope.isMeta;
    const isUpsell = Odigeo.Utils.isRequestApp('upsell');
    const isPrimeActive = Odigeo.Membership.isMembershipProductEnabled;
    if (Odigeo.AB.isAutomaticCheckinPaxDesktop || Odigeo.AB.isSmsPaxPageDesktop) {
        ancillariesGeneric.initialize();
    }
    Odigeo.Session.set('isAccommodationPostBooking', false);
    Odigeo.Session.set('isRefundableFareUpgradeSetInPax', false);
    Odigeo.Session.set('isRefundableFareUpgradeShowInPax', false);
    var widgets = Odigeo.autoloadWidgets({
        accommodationDetails: ['accommodation-details', 'accommodation_details'],
        nagManager: ['nagmanager', 'nagmanager'],
        getMembershipSubscription: ['membership-subscription', 'membership_subscription'],
        passengersModifier: ['passengers-update', 'passengers_update'],
        smartNagBaggage: ['smart-nag-baggage', 'smart_nag_baggage'],
        bookFlightManager: ['book-flight-manager', 'book_flight_manager'],
        gdprNewsletter: ['gdpr-newsletter', 'gdpr_newsletter'],
    });
    var isSidebarSummary = $('.side_summary_details').data('type') === 'sidebarsummary';
    const asyncWidgets = Odigeo.autoloadWidgetsAsync({
        dpWaitingPage: ['dpwaiting-page', 'dp_waiting_page'],
        dpSearchNoResults: ['dp-search-no-results', 'dp_search_no_results'],
        seatMapSelectionManager: ['seatmap-selection-manager', 'seatmap_selection_manager'],
        getSidebar: isSidebarSummary ? ['sidebar-summary', 'sidebar_summary'] : ['trip-summary-price', 'trip_summary_price'],
        getMembershipManager: ['membership-manager', 'membership_manager'],
        getUsersManager: ['users-manager', 'usersmanager'],
        getAccommodationSearchManager: ['accommodation-search-manager', 'accommodation_search_manager'],
        getShoppingCartManager: ['shoppingcart-manager', 'shoppingcartmanager'],
        getHandBaggageSummary: ['hand-baggage-summary', 'hand_baggage_summary'],
        getBoardingOptions: ['boarding-options', 'boarding_options'],
        getSeatsLeftOnTop: ['seatsLeftOnTopPaymentPage', 'seats_left_on_top'],
        getFlightSummary: ['collapsible-flight-summary', 'collapsible_flight_summary'],
        getFlightSummaryDetails: ['collapsible-flight-summary-details', 'collapsible_flight_summary'],
        getDetailsManager: ['details-manager', 'details_manager'],
        getWaitings: ['waiting-pages', 'waiting_pages'],
        getMembershipPricesTracker: ['membership-prices-tracker', 'membership_prices_tracker'],
        getAncillariesModuleMain: ['ancillaries-module-details', 'ancillaries_module'],
        getAncillariesModuleBeneathPhone: ['ancillaries-module-details-beneath-phone-number', 'ancillaries_module'],
        getAncillariesModulePayment: ['ancillaries-module', 'ancillaries_module'],
    });
    const widgetLoader = createWidgetLoader({
        login: ['login-header', loginFactory],
        aircraftMapManager: ['aircraft_map_manager', aircraftmapManagerFactory],
        membershipResidentNag: ['membership-resident-nag', residentNagFactory],
        passengersSidebar: ['passengers_sidebar', sidebarFactory(), {page: 'details', isDynpack, isUpsell, isMktPortal, isPrimeActive}],
        membershipRenewal: ['membership-renewal', membershipRenewalFactory],
        expensiveRepricingManager: ['expensive-repricing-manager', myExpensiveRepricingManagerFactory],
        cheapRepricingManager: ['cheap-repricing-manager', myCheapRepricingManagerFactory],
        fareFamilies: ['fare-family', fareFamiliesFactory],
        cartDebugger: ['cart-debugger', cartDebuggerFactory],
        membershipInfoLightbox: ['membership-perks-info-lightbox', membershipPerksLightbox],
        ancillariesSummary: ['ancillaries-summary', ancillariesSummaryFactory],
        freeCancellation: ['free-cancellation', freeCancellationFactory],
        bags: ['ancillaries-component-bags', ancillaries, {child: baggageFactory, childContainer: '#baggage-wrapper'}],
        fareRules: ['fare-rules', fareRulesFactory],
        residentDiscount: ['resident-discount', residentDiscountFactory],
    });
    const $page = $(`#${PAGE}`);
    const getBookingId = () => $page.find('.details_manager_data').data('bookingid');
    const setBookingId = (bookingID) => $page.find('.details_manager_data').data('bookingid', bookingID.toString());

    const dpSearchInSecure = () => {
        $.extend(true, Odigeo.Router.eventController, errorsEventController, dynpackSearchSecureController);
        commonDpResultsUtils.startWidgets(asyncWidgets);
        Odigeo.Router.eventController.execute();
        Odigeo.trigger('dpsearch-manager:launchSearchAndConfirm', deeplink, PAGE);
    };

    if (Odigeo.AB.isDpSearchInSecure && Dynpack.isPreparedToLaunchSearchInSecure()) {
        dpSearchInSecure();
        return;
    }

    if (!Odigeo._.isEmpty(repricingMAPI) && JSON.parse(repricingMAPI.exceededMaxThreshold || false)) {
        const totalPriceDifference = repricingMAPI.totalPriceDifference;
        logger.message(`RepricingMAPI in details handler: ${repricingMAPI}`);
        widgetLoader.get('expensiveRepricingManager').execute('toggleExpensiveRepricing', true);
        widgetLoader.get('cheapRepricingManager').execute('toggleMetasCheapRepricing', totalPriceDifference, repricingMAPI);
    }
    const openLoginForm = Odigeo._.partial(require('../modules/helpers/user.js').openLoginForm, trackingUtils, widgetLoader);
    var $html = $('html,body');
    var $window = $(window);
    var $mainContainer = $('.home_main_layout');
    var $logo = $('#logo');
    var beforePage = Odigeo.Session.get('before-page');
    var SearchController = require('../modules/controllers/search_controller');
    trackingAncillariesContinuance.resetPolicySession();
    var $waitingPages = $('.waiting_page');
    var isForceLoginPopupOpened = false;
    let isUpdatedMembershipPrices = false;
    let onLoadFreqFlyerTracked = false;
    let customDimension54Tracked = false;
    let readyForTrackingCustomDimension54 = false;
    asyncWidgets.getSidebar().execute('setIsUpdatedMembershipPrices', isUpdatedMembershipPrices);
    asyncWidgets.getSidebar().execute('setPage', PAGE);

    let user;
    let scrollPosition = 0;
    const toggleViewPortLock = function(toggle) {
        if (toggle) {
            scrollPosition = $window.scrollTop();
        }
        Odigeo.Device.getViewport().toggleClass('od-viewport-locked', toggle).promise().done(function() {
            if (!toggle) {
                $window.scrollTop(scrollPosition);
            }
        });
    };
    var searchController = new SearchController(
        {
            directFlightSearchManager: ['direct_flights_search_manager', 'direct_flights_search_manager'],
            flightTypeSearchManager: ['flight_type_search_manager', 'flight_type_search_manager'],
            passengersSelectorSearchManager: ['passengers_search_manager', 'passengers_search_manager'],
            onelineButtonSearch: ['onelinebutton_search_manager', 'onelinebutton_search_manager'],
            onelineCabinClass: ['oneline_cabinclass', 'oneline_cabinclass'],
            itinerarySearchManager: ['itinerary_search_manager', 'itinerary_search_manager'],
        },
        {
            searchParam: 'searchParameters',
            omittedParams: ['airlinesCodes'],
        }
    );
    let loadedWidgets = new Set();

    let cssVisibilityClass = '';
    switch (Odigeo.SessionScope.brand) {
        case 'ED': cssVisibilityClass = 'od-payment-visibility-ed';
            break;
        case 'OP': cssVisibilityClass = 'od-payment-visibility-op';
            break;
        case 'GV':
        case 'GO': cssVisibilityClass = 'od-payment-visibility-go';
            break;
        default: cssVisibilityClass = 'od-payment-visibility-ed';
            break;
    }
    $('#prime_visibility_header').removeClass('od-header-funnel-info-visibility-payment').removeClass(cssVisibilityClass);
    $('#bread_crumb_savings_visibility').addClass('odf-hidden');

    $.extend(true, Odigeo.Router.eventController,
        Odigeo.Router.handlers.userEventController,
        Odigeo.Router.handlers.globalEventController,
        Odigeo.Router.handlers.errorManagerEventController,
        Odigeo.Router.handlers.searchFlightsEventController,
        Odigeo.Router.handlers.repriceManagerEventController, {
            globalEvents: {
                'dpsearch-manager:retryDynpackDeeplink': 'retryDynpackDeeplink',
            },
            viewEvents: Odigeo._.extend(handlerUtils.viewEvents, ancillariesGeneric.viewEvents(), {
                'drawer-generic:toggleViewPortLock': 'onToggleViewPortLock',
                'resident-discount-pax:updateProductsInSession': 'onUpdateProductsInSession',
                'shoppingcart-manager:requestCompletedSuccessfully': 'onSCManagerRequestCompletedSuccessfully',
                'shoppingcart-manager:successDeleteHotelFromCart': 'onSuccessDeleteHotelFromCart',
                'shoppingcart-manager:errorDeleteHotelFromCart': 'onErrorDeleteHotelFromCart',
                'getTotalByFullprice': 'onTotalByFullPrice',
                'continueTransitionToPayment': 'onContinueTransitionToPayment',
                'global:userNotLogged': 'onNotLoggedUser',
                'global:userLogged': 'onLoggedUser',
                'global:userNotLoggedRemembered': 'onNotLoggedUserRemembered',
                'users-manager:updateAccountInfoOk': 'onUpdateTraveller',
                'users-manager:updateAccountInfoWithError': 'onResetTravellersData',
                'users-manager:updateAccountInfoError': 'onResetTravellersData',
                'users-manager:loginOk': 'onRemembermeLoginOk',
                'users-manager:loginWithError': 'onRemembermeLoginError',
                'users-manager:loginError': 'onRemembermeLoginError',
                'global:repricingShown': 'onRepricing',
                'passengers_manager:completed': 'onPassengerPageComplete',
                /* collapsible events */
                'expanded-summary:panelCollapsed': 'onExpandedSummaryClosed',
                'collapsed-summary:panelCollapsed': 'onCollapsedSummaryClosed',
                'passengers_manager:travellerSelected': 'onHideTravellerSelected',
                'passengers_manager:travellerChanged': 'onTravellerChanged',
                'passengers_manager:travellerNotSelected': 'onShowTravellerSelected',
                'passengers_manager:submitUserResultRequest': 'onSubmitUserResultRequest',
                'passengers_manager:addTravellerData': 'onAddTravellerData',
                'passengers_manager:sendNameToSidebar': 'onSendNameToSidebar',
                'passengers_manager:continueButtonBinding': 'continueButtonBinding',
                'passengers_manager:openLoginForm': 'onOpenLoginForm',
                'passengers_manager:closeForceLoginPopup': 'onCloseForceLoginPopup',
                'passengers_manager:residentDoesntMatchNames': 'onResidentNotMatchingNames',
                'passengers_manager:removePax': 'onChangePaxNumber',
                'onelinebutton_search_manager:editSearch': 'onEditSearch',
                'oneline-search-manager:showOnelineSearch': 'onShowOnelineSearch',
                'sidebar-summary:openFlightDetails': 'onOpenFlightDetails',
                'sidebar-summary:addPaxSidebar': 'onChangePaxNumber',
                'details-manager:openPriceBreakdown': 'onOpenPriceBreakdown',
                'seatmap-selection-manager:seatMapSelected': 'onSeatMapSelection',
                'seatmap-selection-manager:scrollToSeatMapSelection': 'onScrollToSeatMapSelection',
                'seatmap-selection-manager:openAircraftMap': 'onOpenAircraftMap',
                'seatmap-selection-manager:showDeleteAllDialog': 'onShowDeleteAllDialog',
                'seatmap-selection-manager:resetSeatmapSelection': 'onResetSeatmapSelection',
                'seatmap-selection-manager:severalRetries': 'onSCManagerRequestCompletedSuccessfully',
                'seatmap-selection-manager:showNoSeatsSelectedDialog': 'onShowNoSeatsSelectedDialog',
                'seatmap-selection-manager:nagSubscribe': 'onNagSubscriber',
                'seatmap-selection-manager:notifyNagProductEnabled': 'onNotifyNagProductEnabled',
                'seatmap-selection-manager:primeMerchandisingBadgeDisplayed': 'onPrimeMerchandisingBadgeDisplayed',
                'aircraftmap_manager:closeAircraftMap': 'onCloseAircraftMap',
                'aircraftmap_manager:scrollToSeatMapSelection': 'onScrollToSeatMapSelection',
                'aircraftmap_manager:tapNavigateButton': 'onTapAircraftMapNavigateButton',
                'aircraftmap_manager:keepSeatMapSelection': 'onKeepSeatMapSelection',
                'aircraftmap_manager:removeSeatMapSelection': 'onRemoveSeatMapSelection',
                'aircraftmap_manager:showNoSeatsSelectedDialog': 'onShowNoSeatsSelectedDialog',
                'aircraftmap_manager:closeSeatMap': 'onCloseAircraftMap',
                'aircraftmap_manager:updateSidebarSummary': 'onSelectSeatUpdateSidebarSummary',
                'aircraftmap_manager:updateSeatSelectionFees': 'onUpdateSeatSelectionFees',
                'seatmap_selection_manager:updateSidebarSummary': 'onSelectSeatUpdateSidebarSummary',
                'dpwaiting-page:activateDpWaitingPage': 'activateDpWaitingPage',
                'dpwaiting-page:cleanDpWaitingPage': 'cleaningDpWaitingPage',
                'dpwaiting-page:hidePageOverDpWaitingPage': 'hiddenPageOverDpWaitingPage',
                'flight-details:toggleDetails': 'onDpToggleAccommodationDetails',
                'flight-details-open-search:toggleDetails': 'onDpToggleAccommodationDetails',
                'sidebarFlightInfo:changeDPSelection': 'sendUserToDpResults',
                'trip-summary-price:sendUserToDpResults': 'sendUserToDpResults',
                'trip-summary-price:removeHotel': 'showRemoveHotelNag',
                'sidebarHotelInfo:removeHotel': 'showRemoveHotelNag',
                'trip-summary-price:toggleDetails': 'onDpToggleAccommodationDetails',
                'sidebar-summary:toggleDetails': 'onDpToggleAccommodationDetails',
                'sidebar-summary:removeHotel': 'showRemoveHotelNag',
                'sidebar-summary:sendUserToDpResults': 'sendUserToDpResults',
                'trip-summary-price:addPaxSidebar': 'onChangePaxNumber',
                'flight-details:closeAccommodation': 'closeAccommodationDeTails',
                'nagmanager:addBaggages': 'onNagManagerAddBaggages',
                'nagmanager:continue': 'onNagManagerContinue',
                'nagmanager:evenUpBaggageSelection': 'onEvenUpBaggageSelection',
                'baggage-wrapper:nagSubscribe': 'onNagSubscriber',
                'baggage-wrapper:notifyNagProductEnabled': 'onNotifyNagProductEnabled',
                'baggage-wrapper:primeMerchandisingBadgeDisplayed': 'onPrimeMerchandisingBadgeDisplayed',
                'nagmanager:goToSeats': 'onGoToSeats',
                'nagmanager:addPrime': 'onLaunchTravellersValidations',
                'nagmanager:requestXsellAccommodationResults': 'onBeforeRequestXsellAccommodationResultsFromNag',
                'detail-search-summary:showHeaderBackgroundSearchSummary': 'onRemoveBackgroundHeaderSearchSummary',
                'seatmap-selection-manager:passengerCollectionIsPopulated': 'onPassengerCollectionPopulated',
                'seatmap-selection-manager:disablePristineMoveThrough': 'onDisablePristineMoveThrough',
                'passengers-update:addPaxCompleteSuccessful': 'onAddPaxCompleteSuccessful',
                'membership-subscription:launchTravellersValidations': 'onLaunchTravellersValidations',
                'passengers-update:addPaxCompleteError': 'onAddPaxCompleteError',
                'shoppingcart-manager:requestCompletedWithError': 'onSCManagerRequestCompletedWithError',
                'membership:refreshWidgets': 'onMembershipRefreshWidgets',
                'membership:refreshSubscription': 'onMembershipRefreshSubscription',
                'membership:updatePremiumDisclaimers': 'onUpdatePremiumDisclaimers',
                'membership-manager:getUserTypeOk': 'onGetUserTypeResponse',
                'membership-manager:getUserTypeFail': 'onGetUserTypeResponse',
                'membership-manager:addMembershipOk': 'onAddMembershipResponse',
                'membership-manager:addMembershipFail': 'onAddMembershipResponse',
                'membership-manager:addMembershipFailRetry': 'onAddMembershipResponseFailRetry',
                'membership-manager:addMembershipComplete': 'onAddMembershipResponseFinished',
                'membership-subscription-error:tryAgain': 'onSubscriptionErrorTryAgain',
                'membership-subscription-error:cancel': 'onSubscriptionErrorCancel',
                'membership-subscription:membershipSubscriptionChange': 'onMembershipSubscriptionChange',
                'membership-subscription:trackMembersipPrices': 'onTrackMembershipPrices',
                'membership-subscription:openLoginForm': 'onOpenLoginForm',
                'membership-subscription:openMembershipPerksInfoLightbox': 'onOpenMembershipPerksInfoLightbox',
                'membership-subscription:getTravellersSelected': 'onGetTravellersSelected',
                'users-manager:registerOk': 'onRegisterEvent',
                'users-manager:registerWithError': 'onRegisterEvent',
                'users-manager:registerError': 'onRegisterEvent',
                'membership-perks-info-lightbox:openOrClosePerksMembershipDialog': 'onOpenOrCloseMembershipDialog',
                'membership-perks-info-lightbox:launchTravellersValidations': 'onLaunchTravellersValidations',
                'share-itinerary-details:onShareEmailSearch': 'onShareEmailSearch',
                'membership-renewal:openMembershipPerksInfoLightbox': 'onOpenMembershipPerksInfoLightbox',
                'membership-renewal:membershipSubscriptionChange': 'onMembershipSubscriptionRenewalChange',
                'membership-login:openLoginForm': 'onOpenLoginForm',
                'price-section-details:openPriceBreakdown': 'onOpenPriceBreakdown',
                /** Recaptcha */
                'recaptcha:loaded': 'onRecaptchaLoaded',
                'promotional-codes:updatePromocode': 'onUpdatePromocode',
                'accommodation-search-manager:resultsLoaded': 'onSuccessAccommodationSearch',
                'accommodation-search-manager:resultsNotAvailable': 'onErrorAccommodationSearch',
                'smart-nag-baggage:showSmartNagBaggage': 'onShowSmartNagBaggage',
                'smart-nag-baggage:updateSelectedBaggageFromSmartnag': 'onUpdateSelectedBaggageFromSmartnag',
                'boarding-options:onBoardingOptionSelected': 'onBoardingOptionSelected',
                'boarding-options:onBoardingOptionInteracted': 'onBoardingOptionInteracted',
                'collapsible-flight-summary:changeCurrentSearch': 'onShowSearchBar',
                'frontend-shell:openChangeSearch': 'onShowSearchBar',
                'oneline-search-manager:hideSearchBar': 'toggleSearchBar',
                'boarding-options:showPriorityBoardingNag': 'onShowPriorityBoardingNag',
                'boarding-options:boardingOptionsLoaded': 'onBoardingOptionsLoaded',
                'fare-upgrade-c4ar:setRefundableFareUpgradeShown': 'onSetRefundableFareUpgradeShown',
                'fare-family:fareFamilySelected': 'onFareFamilySelected',
                'book-flight-manager:shoppingCartCreated': 'onShoppingCartCreated',
                'fare-upgrade-selector:setRefundableFareUpgradeShown': 'onSetRefundableFareUpgradeShown',
                'flight-details:showFlightDetails': 'onShowFlightDetails',
                'conchita:FareRules:FareSelector:onSelect': 'onFareRuleSelect',
                'frontend-shell:flexibility-bundle:onSelect': 'onFareRuleSelectOF2',
                'conchita:FareRules:loaded': 'onFareRulesLoaded',
                'frontend-shell:flexibility-bundle:loaded': 'onFareRulesLoadedOF2',
                'passengers_manager:frequentFlyerShown': 'onFrequentFlyerShown',
                'price-section-details:trackCustomDimensionSidebar': 'onTrackCustomDimensionSidebar',
                'frontend-shell:cabin-bags:nag-selection-confirmed': 'onCabinBagsNagSelectionConfirmed',
                'frontend-shell:cabin-bags:nag-loading-error': 'onCabinBagsNagLoadingError',
                'frontend-shell:cabin-bags:boarding-options-selected': 'onBoardingOptionSelectedOF2',
                'widgetLoaded': 'onWidgetLoaded',
                'frontend-shell:fast-track:toggle': 'onFastTrackToggle',
                'frontend-shell:fareSelectedQuickAddPrime': 'onFareSelectedInPaxPage',
                'frontend-shell:fareRemovedQuickAddPrime': 'onFareRemovedInPaxPage',
                'frontend-shell:fareSelectedInDualDisplay': 'onFareSelectedInDualDisplay',
                'frontend-shell:fareRemovedInDualDisplay': 'onFareRemovedInDualDisplay',
            }),
            eventHandlers: Odigeo._.extend(handlerUtils.eventHandlers, ancillariesGeneric.eventHandlers(), {
                onWidgetLoaded: (widget) => {
                    loadedWidgets.add(widget);
                    if (loadedWidgets.has('details_manager')) {
                        $('.od-skeleton-details-wrapper').addClass('loaded');
                        $('.od-skeleton-details').remove();
                        if (loadedWidgets.has('fare_rules')) {
                            $('.od-skeleton-fare-rules-wrapper').addClass('loaded');
                            $('.od-skeleton-fare-rules').remove();
                            $('.details_progressive_disclosure').removeClass('odf-hidden');
                        } else {
                            $('.details_progressive_disclosure').removeClass('odf-hidden');
                        }
                    }
                },
                retryDynpackDeeplink: () => {
                    if (Odigeo.AB.isDpSearchInSecure && Dynpack.isPreparedToLaunchSearchInSecure()) {
                        dpSearchInSecure();
                    } else {
                        window.location.reload();
                    }
                },
                onResidentNotMatchingNames: function(params) {
                    widgetLoader.get('membershipResidentNag').execute('showResidentNag', params);
                },
                onUpdatePromocode: function(promoCode) {
                    asyncWidgets.getSidebar().execute('updatePromocode', promoCode);
                },
                onSuccessAccommodationSearch: function(data) {
                    const minResults = Odigeo.UIElements.translations.xsellIntermediatePage.minResults ?
                        Odigeo.UIElements.translations.xsellIntermediatePage.minResults :
                        1;
                    if (data.messages || data.errors) {
                        this.onErrorAccommodationSearch();
                    } else if (data.accommodationSearchResultsMetadata.numResults >= minResults) {
                        Odigeo.Session.set('intPageAccommodationResults', JSON.stringify(data));
                        widgets.nagManager().execute('showHotelsReminderNag');
                    }
                },
                onErrorAccommodationSearch: function() {
                    if (Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters')).type === 'roundTrip') {
                        trackingUtils.trackEvent('nags', 'nag_hotel_upsell_not_shown_' + 'sesionerror');
                    }
                },
                onShowSearchBar: function(show) {
                    Odigeo.requireWidget('oneline-search-manager', 'onelinesearchmanager', function(onelinerWidget) {
                        onelinerWidget.execute('displaySearchBar', show);
                    });
                    this.toggleSearchBar(show);
                },
                toggleSearchBar: function(show) {
                    if (Odigeo.AB.isCssVariationHeaderDesktop) {
                        $header.toggleClass('od-header-shadow-cobalt', !show);
                    }
                    $oneLineSearchBg.toggleClass('expanded', show);
                    _collapsibleFlightSummaryLauncher('enableChangeSearch', show);
                },
                onBeforeRequestXsellAccommodationResultsFromNag: function() {
                    asyncWidgets.getAccommodationSearchManager().execute('sendTrackNagAccommodation');
                    this.onRequestXsellAccommodationResults();
                },
                onRequestXsellAccommodationResults: function() {
                    window.onbeforeunload = null;
                    waitingHelper.fillWaitingPage(Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters')));
                    $waitingPages.addClass('od-waiting-intermediate');
                    Odigeo.UIElements.enhanceLoading($waitingPages)
                        .showLoading(['waiting_intermediate_page', 'waiting_flight_info', 'waiting_intermediate_footer']);
                    Odigeo.Session.set('ipHotelReminderNagShown', true);
                    Odigeo.Session.set('intermediatePageShown', false);
                    xsellUtils.navigateToNonSecure('xsellproductselection');
                },
                onSelectSeatUpdateSidebarSummary(seatMapCollection) {
                    const {length} = seatMapCollection;

                    if (isSidebarSummary) {
                        asyncWidgets.getSidebar().execute('onSeatmapChange', seatMapCollection);
                    }

                    Odigeo.Session.set(CONS.NUM_SELECTED_SEATS, length);
                    this.onTotalByFullPrice();
                },
                onPassengerCollectionPopulated: function() {
                    widgetLoader.get('aircraftMapManager').execute('checkPassengerCollectionPopulated');
                },
                onDisablePristineMoveThrough: function() {
                    widgetLoader.get('aircraftMapManager').execute('cancelAircraftMoveThrough');
                },
                onMembershipRefreshSubscription: function(action) {
                    var isLogin = action === 'login';
                    widgets.getMembershipSubscription().execute(!isLogin ? 'showWidget' : 'hideWidget', isLogin);
                },
                trackErrorAndMessages: function(errors, type) {
                    Odigeo._.each(errors, function(error) {
                        if (!Odigeo._.isEmpty(error.code)) {
                            trackingUtils.trackEvent('intermediate_page_on_load', 'intermediate_page_not_shown_' + type + error.code);
                        }
                    });
                },
                onUpdateBubblePremium: function(membershipSettings) {
                    const renderedBubblePremiumPromise = asyncWidgets.getSidebar().get('updateBubblePremium', membershipSettings);
                    renderedBubblePremiumPromise.then((renderedBubblePremium) => {
                        asyncWidgets.getDetailsManager().execute('setPremiumBubble', renderedBubblePremium);
                    });
                    if (Odigeo.Membership.isMembershipProductEnabledDesktop) {
                        this.updateSmoothPrice();
                    }
                },
                onMembershipRefreshWidgets: function(action, isSubscriptionAdded) {
                    asyncWidgets.getSidebar().execute('updatePriceMemberDisplay', action, isSubscriptionAdded);
                    asyncWidgets.getSidebar().execute('updatePriceMemberDisplayPrices', action, isSubscriptionAdded);
                },
                onAddMembershipResponseFinished: function() {
                    toggleContinueToPaymentBtn(false);
                },
                onGetTravellersSelected: function() {
                    let data = getListOfTravellers();
                    widgetLoader.get('login').get('isLogged').then((isUserLogged) => {
                        if (!isUserLogged) {
                            asyncWidgets.getMembershipManager().execute('getUserType', data.email);
                        } else {
                            Odigeo._.extend(data, {isLogged: isUserLogged});
                            widgets.getMembershipSubscription().execute('setListOfTravellers', data);
                            widgets.getMembershipSubscription().execute('renderLightBoxTemplate');
                            widgets.getMembershipSubscription().execute('trackGetMembershipLightBox', 'widget_appears', data);
                        }
                    });
                },
                onOpenMembershipPerksInfoLightbox: function() {
                    widgetLoader.get('membershipInfoLightbox').execute('openMembershipPerksInfoLightbox');
                },
                onOpenOrCloseMembershipDialog: function(opened) {
                    fixScrollingBehindModalLightbox(opened);
                },
                onGetUserTypeResponse: function(response) {
                    const {isMembershipProductEnabledDesktop} = Odigeo.Membership;
                    let data;
                    widgetLoader.get('login').get('isLogged').then((isUserLogged) => {
                        if (!isMembershipProductEnabledDesktop) {
                            this.membershipSubscriptionValidateUserTypeOk(data, isUserLogged, response);
                        }
                    });
                },
                membershipSubscriptionValidateUserTypeOk(data, isUserLogged, response) {
                    data = getListOfTravellers();
                    Odigeo._.extend(data, {isLogged: isUserLogged, status: response});
                    widgets.getMembershipSubscription().execute('setListOfTravellers', data);
                    widgets.getMembershipSubscription().execute('renderLightBoxTemplate');
                    widgets.getMembershipSubscription().execute('trackGetMembershipLightBox', 'widget_appears', data);
                },
                onCloseForceLoginPopup: function() {
                    isForceLoginPopupOpened = false;
                },
                onAddMembershipResponse: function(response) {
                    if (!Odigeo._.isEmpty(response)) {
                        manageAddMembershipError(response[0]);
                    } else {
                        Odigeo.trigger('continueTransitionToPayment');
                    }
                    this.onAddMembershipResponseFinished();
                },
                onAddMembershipResponseFailRetry: function(response) {
                    if (response[0] && response[0].code === CONS.UNL_MEMBERSHIP_ALREADY_MEMBER ) {
                        Odigeo.UIElements.showLightboxWarning('od-passenger-lightbox-logout',
                            solveAddMembershipError.bind(response[0]), null,
                            Odigeo.UIElements.translations.errMembershipSubscription.memberExists);
                        this.onAddMembershipResponseFinished();
                    } else {
                        if (!this.errorContainer) {
                            this.errorContainer = membershipSubscriptionErrorFactory.create({
                                id: 'membership-subscription-error',
                                el: $page.find('.subscription_prime_error_container'),
                                model: this.model,
                                options: {
                                    page: 'pax',
                                    template: 'main',
                                },
                            });
                        }
                        this.errorContainer.execute('renderTemplate', Odigeo.Utils.parseJson(Odigeo.Session.get('isUserSubscribedItem')));
                        $page.find('.subscription_prime_error_container').addClass('open');
                    }
                },

                onUpdatePremiumDisclaimers: function(isMemberSelected, isFreeAccount, isPrimeTravellerUnselected) {
                    var isMembershipDualDisplay = $page.find('.details_manager_data').data('membershipdualdisplay');
                    var noMemberSelectedAction = isMembershipDualDisplay ? 'noDiscount' : 'logout';
                    var action = isMemberSelected ? 'login' : noMemberSelectedAction;
                    var membershipSettings = {
                        isMemberTestActive: isMembershipDualDisplay,
                        memberInTravellers: isMemberSelected,
                        isMemberLogged: true,
                        isFreeAccount: isFreeAccount,
                        isPrimeTravellerUnselected: isPrimeTravellerUnselected,
                        isCheapestPriceSelected: $page.find('.details_manager_data').data('discountselected'),
                    };
                    isMemberInTravellers = isMemberSelected;
                    this.onUpdateBubblePremium(membershipSettings);
                    if (isMemberSelected || isPrimeTravellerUnselected) {
                        asyncWidgets.getSidebar().execute('updatePriceMemberDisplayPrices', action);
                    }
                    asyncWidgets.getSidebar().execute('updatePremiumDisclaimers', isMemberSelected);
                    if (Odigeo.Membership.isMembershipRenewalAtFirstBooking) {
                        widgetLoader.get('membershipRenewal').execute('isRenewalAtFirstBooking');
                    }
                },
                onLaunchTravellersValidations: function() {
                    hasErrors = false;
                    validatePassengers();
                    if (!Odigeo.Membership.isMembershipProductEnabledDesktop) {
                        widgets.getMembershipSubscription().execute(hasErrors ? 'alertDisclaimer' : 'openLightBox', hasErrors);
                    }
                },
                onSubscriptionErrorTryAgain: function() {
                    const newRequestData = Odigeo.Utils.parseJson(Odigeo.Session.get('membershipProductPreviousRequest'));
                    Odigeo.Session.remove('membershipProductPreviousRequest');
                    asyncWidgets.getMembershipManager().execute('addMembership', newRequestData);
                    $page.find('.subscription_prime_error_container').removeClass('open');
                },
                onSubscriptionErrorCancel: function() {
                    Odigeo.Session.remove('membershipProductPreviousRequest');
                    $page.find('.subscription_prime_error_container').removeClass('open');
                    widgets.getMembershipSubscription().execute('deleteMembership');
                    continueButtonBinding();
                },
                onRegisterEvent: function(data) {
                    asyncWidgets.getSidebar().execute('togglePriceLoading', false);
                },
                onUpdateTraveller: function(data) {
                    this.onResetTravellersData();
                    if (Odigeo._.isObject(data) && data.responseOK) {
                        Odigeo.requireWidget('passengers0', 'passengers_manager', function(passenger) {
                            passenger.execute('updatePassengerListSelected', data);
                        });
                        _buyerEventLauncher('updatePassengerListSelected', data);
                    }
                },

                onResetTravellersData: function() {
                    passengerSaveList = [];
                    contactDetailsData = {};
                },

                onSCManagerRequestCompletedWithError: function() {
                    toggleContinueToPaymentBtn(false);
                },

                onEditSearch: function() {
                    $oneLineSearchBg.addClass('expanded');
                },

                onShowOnelineSearch: function(show) {
                    $oneLineSearchBg.toggleClass('active', show);
                },

                onShareEmailSearch: function(evt, data) {
                    Odigeo.requireWidget('share-selection', 'share_selection', function(widget) {
                        widget.execute('setShareSelectionEl', evt.currentTarget);
                        widget.execute('reset', data);
                    });
                },

                onAddTravellerData: function(data, type) {
                    if (type === 'passenger') {
                        passengerSaveList.push(data);
                    } else if (type === 'contactDetails') {
                        contactDetailsData = data;
                    }
                    if (passengerSaveList.length === $passengerManagerArray.length - 1 && !Odigeo._.isEmpty(contactDetailsData)) {
                        passengerSaveList = Odigeo._.reject(passengerSaveList, function(passenger) {
                            return passenger.traveller.id === 0;
                        });
                        _submitUserResultRequest('saveAllPassengersData', {
                            passengers: passengerSaveList,
                            contactDetails: contactDetailsData,
                        });
                    }
                },

                onSendNameToSidebar: function(data) {
                    asyncWidgets.getSidebar().execute('updateTravellersName', data);
                },

                onOpenFlightDetails: function(event, hasToTrack) {
                    var flightDetailsId = 'flight-details';
                    $html.animate({scrollTop: 100}, 100);
                    flightDetailsId = $page.find('#flight-details-open-search').length > 0 ? 'flight-details-open-search' : flightDetailsId;
                    Odigeo.requireWidget(flightDetailsId, 'flight_details', function(flightDetails) {
                        flightDetails.execute('toggleViewPanel', event, hasToTrack);
                    });
                },

                onChangePaxNumber: function(e) {
                    localforage.clear();
                    Odigeo.requireWidget('passengers-update', 'passengers-update', function(paxUpdate) {
                        paxUpdate.execute('addPax', e);
                    });
                },

                onSubmitUserResultRequest: function(action, data) {
                    _submitUserResultRequest(action, data);
                },

                onHideTravellerSelected: function(id) {
                    _passengerEventLauncher('hideTraveller', id);
                },
                onTravellerChanged: function(changePaxMethods) {
                    frontendShell.execute(({traveller}) => {
                        traveller.change({
                            onChange: changePaxMethods?.changePaxCallback || null,
                            onDontChange: changePaxMethods?.dontChangePaxCallback || null,
                        });
                    });
                },
                onCollapsedSummaryClosed: function() {
                    _collapsibleFlightSummaryLauncher('expandSummaryPanel', true);
                },
                onExpandedSummaryClosed: function() {
                    _collapsibleFlightSummaryLauncher('expandSummaryPanel', false);
                },

                onShowTravellerSelected: function(id) {
                    _passengerEventLauncher('showTraveller', id);
                },

                onToggleViewPortLock: function(value) {
                    toggleViewPortLock(value);
                },

                onNotLoggedUser: function() {
                    if (Odigeo.AB.isFixRestorePaxPage) {
                        restoreFieldsFromPassengersData();
                    }
                    user = null;
                    $customerBuyerManager.addClass('localStorageEnabled').removeClass('userLogged');
                    $detailsLogin.removeClass('hidden');
                    $detailsLogin.find('.login_button').off().on(Odigeo.Events.tap, openLoginForm);
                    _remembermeEventLauncher('enableRememberMe', false);
                    _passengerEventLauncher('userNotLoggedHidePassengerList');
                    _buyerEventLauncher('userNotLoggedHideNonEditableBuyerLayer');
                    this.updateMembershipPrices($page.find('.details_manager_data').data('membershipdualdisplay'));
                    widgets.getMembershipSubscription().execute('logoutDone');
                    widgets.getMembershipSubscription().execute('checkPreviouslyAddedProduct');
                    widgets.nagManager().execute('logoutDone');
                    widgetLoader.get('membershipInfoLightbox').execute('logoutDone');
                    readyForTrackingCustomDimension54 = true;
                },

                updateMembershipPrices: function(isMembershipDualDisplay, isSubscriptionAdded, membershipPrice, isPriceWithoutDiscountSelected) {
                    const isCheapestPriceSelected =
                        !Odigeo._.isUndefined(isPriceWithoutDiscountSelected) ?
                            !isPriceWithoutDiscountSelected :
                            $page.find('.details_manager_data').data('discountselected');
                    const membershipSettings = {
                        isCheapestPriceSelected,
                        isMemberTestActive: isMembershipDualDisplay,
                        isMemberLogged: !Odigeo._.isEmpty(user),
                        isSubscriptionAdded,
                        membershipPrice,
                    };

                    isUpdatedMembershipPrices = true;
                    asyncWidgets.getSidebar().execute('setIsUpdatedMembershipPrices', true);
                    if (!Odigeo._.isEmpty(user)) {
                        Odigeo._.extend(membershipSettings, {isFreeAccount: !isUserDTOMember(user)});
                    }
                    if (isMembershipDualDisplay) {
                        const action = $page.find('.details_manager_data').data('discountselected') ? 'discount' : 'noDiscount';
                        this.onMembershipRefreshWidgets(action, isSubscriptionAdded);
                    }
                    this.onUpdateBubblePremium(membershipSettings);
                },

                onLoggedUser: function(data, hasTracking) {
                    this.reloadNewBuyerPage();
                    _activateLoggedElements(data.userDTO || data, hasTracking);
                    Odigeo.Session.set('displayName', data.displayName);
                    if (!isUserDTOMember(data.userDTO)) {
                        this.updateMembershipPrices($page.find('.details_manager_data').data('membershipdualdisplay'));
                    }
                    if (isUserDTOMember(data.userDTO)) {
                        asyncWidgets.getMembershipPricesTracker().execute('trackMembershipPrices', true, true);
                    }
                },

                onTrackMembershipPrices: () => {
                    asyncWidgets.getMembershipPricesTracker().execute('trackMembershipPrices', !Odigeo._.isEmpty(user), false);
                },

                onNotLoggedUserRemembered: function() {
                    $customerBuyerManager.addClass('localStorageEnabled').removeClass('userLogged');
                    _passengerEventLauncher('userNotLoggedHidePassengerList');
                    _remembermeEventLauncher('enableRememberMe', true);
                    _buyerEventLauncher('userNotLoggedHideNonEditableBuyerLayer');
                    this.updateMembershipPrices($page.find('.details_manager_data').data('membershipdualdisplay'));
                },

                onRepricing: function() {
                    Odigeo.requireWidget('details-page-top-persuasive-message', 'persuasiveMessaging', function(persuasiveMessaging) {
                        persuasiveMessaging.execute('closeMessage');
                    });
                },
                onUpdateProductsInSession(currentId, newId) {
                    asyncWidgets.getShoppingCartManager().execute('updateSessionAncillaries', {currentId, newId});
                },

                onSCManagerRequestCompletedSuccessfully: function(msg) {
                    const params = isDynpack ? deeplink : '';
                    const isDecouplingPrimeSubscriptionFlow = Odigeo.AB.isDecouplingPrimeSubscriptionFunnel && msg.userTypeDTO !== 'PREMIUM';

                    const legacyRedirectionLogicPage = Odigeo.AB.isMetaAncillariesPageActive && !isDynpack && !isUpsell
                        ? 'metaancillaries'
                        : (Odigeo.AB.isFecoRedirectionToPaymentDesktop && !isDynpack && !isUpsell) ? 'checkout_payment' : 'payment';

                    const page = isDecouplingPrimeSubscriptionFlow
                        ? 'ancillaries'
                        : legacyRedirectionLogicPage;

                    const options = {
                        newPage: 'checkout_payment',
                        bookingId: parseInt(getBookingId(), 10),
                    };
                    emailSuggestion.removeBinds(['email', 'validationMail']);
                    const navigate = () => Odigeo.Router.navigate(page, {params: params, bookingId: parseInt(getBookingId(), 10)});
                    if (Odigeo.AB.isUpdatePersonalInfo) {
                        if (msg.bookingId && msg.bookingId !== parseInt(getBookingId(), 10)) {
                            setBookingId(msg.bookingId);
                            ShoppingCart.updateBookingId(getBookingId());
                        }
                        ShoppingCart.commit({priceBreakdownCalculationMode: PBD_MODE})
                            .then(() => {
                                Odigeo.AB.isDynpackOf2Desktop ? Dynpack.redirectToOF2Page(options) : navigate();
                            })
                            .catch(() => {
                                Odigeo.AB.isDynpackOf2Desktop ? Dynpack.redirectToOF2Page(options) : navigate();
                            });
                    } else {
                        Odigeo.AB.isDynpackOf2Desktop ? Dynpack.redirectToOF2Page(options) : navigate();
                    }
                },

                onPassengerPageComplete: function(data) {
                    doBuyerThingsOnPassengerPageComplete(data);
                },

                addFareUpgradeToShoppingCartWhenC4ARExists() {
                    const fareUpgradeC4ar = getC4AR();

                    if (!Odigeo._.isUndefined(fareUpgradeC4ar)) {
                        addFareUpgradeToShoppingCart(definefareUpgradeToShoppingCart(true, fareUpgradeC4ar.conceptLabel));
                    } else {
                        addFareUpgradeToShoppingCart(definefareUpgradeToShoppingCart(false, ''));
                    }
                },

                onTotalByFullPrice() {
                    this.addFareUpgradeToShoppingCartWhenC4ARExists();
                    this.updateSidebar();
                    this.updateFareRulesPrices();

                    ShoppingCart.subscribe(this.updateSidebar.bind(this));
                    ShoppingCart.subscribe(this.updateFareRulesPrices.bind(this));
                    if (Odigeo.Membership.isMembershipProductEnabledDesktop) {
                        ShoppingCart.subscribe(this.updateSmoothPrice.bind(this));
                    }
                },

                updateFareRulesPrices() {
                    widgetLoader.get('fareRules').execute('updateFareRules');
                },

                updateSidebar() {
                    this.updateSidebarPrices(detailsTotalPriceCalculator.getTotal());
                },

                updateSidebarPrices({sumTotalPrice, totalPriceWithoutDiscount, pricePerPassenger, isSlowLoadingPrimePriceFix} = {}) {
                    const $sidebarLocator = $page.find('.sidebar_details');
                    const formattedPricePerPassenger = Odigeo.Utils.formatCurrency(pricePerPassenger);
                    if (isSlowLoadingPrimePriceFix) {
                        asyncWidgets.getSidebar().execute('refreshPrice');
                    } else {
                        $sidebarLocator.find('.total_price').html(Odigeo.Utils.formatCurrency(sumTotalPrice));
                    }
                    $sidebarLocator.find('.total_price_without_discount').html(Odigeo.Utils.formatCurrency(totalPriceWithoutDiscount));
                    $sidebarLocator.find('.od-pricebreakdown-table-content-infotable-totalrow .od-js-total-price')
                        .html(Odigeo.Utils.formatCurrency(sumTotalPrice));
                    $sidebarLocator.find('.js-priceperpassenger').html(formattedPricePerPassenger);
                    $sidebarLocator.find('.pax_price').html(formattedPricePerPassenger);
                    $sidebarLocator.find('.total_price').html(Odigeo.Utils.formatCurrency(sumTotalPrice));
                    $sidebarLocator.find('.total_price_tms').attr('data-price-tms', sumTotalPrice);
                    $sidebarLocator.find('.pax_price').html(formattedPricePerPassenger);
                    Odigeo.SessionScope.totalPriceOfShame = {
                        'totalPrice': sumTotalPrice,
                        'totalPricePerPax': pricePerPassenger,
                    };
                    Odigeo.trigger('detailsHandlerSideBarChange');
                },
                updateSmoothPrice() {
                    const {totalPriceWithoutDiscount} = detailsTotalPriceCalculator.getTotal();
                    const {membershipDiscountNumber} = Odigeo.Membership;
                    const flightSelectionData = Odigeo.Utils.parseJson(Odigeo.Session.get('flightSelectionData'));
                    const isFullFareSelected = Odigeo._.get(flightSelectionData, 'data.priceWithoutDiscountSelected', false) || false;
                    const priceWithoutDiscount = Odigeo.Utils.formatCurrency(isFullFareSelected ?
                        totalPriceWithoutDiscount : totalPriceWithoutDiscount + Math.abs(membershipDiscountNumber)
                    );
                    asyncWidgets.getSidebar().execute('refreshSmoothSidebar', {page: 'details', price: priceWithoutDiscount});
                },
                onSeatMapSelection: function(data) {
                    var priceData = data.priceData.data;
                    handlerUtils.seatMapSelectionData = data.seatData;
                    if (!isSidebarSummary) {
                        asyncWidgets.getSidebar().execute('showIncludedSeatMap', priceData);
                    }
                    this.onTotalByFullPrice();
                    widgets.nagManager().execute('updateSeats', 'seatmap-selection', handlerUtils.seatMapSelectionData);
                },
                onOpenAircraftMap: function(seatMap, aircraftOptions) {
                    widgetLoader.get('aircraftMapManager').execute('onOpenAircraftMap', seatMap, aircraftOptions);
                },
                onShowDeleteAllDialog: function(options) {
                    var callbacks = {
                        'keepCallBack': function() {
                            Odigeo.trigger('aircraftmap_manager:keepSeatMapSelection');
                        },
                        'removeCallBack': function() {
                            Odigeo.trigger('aircraftmap_manager:removeSeatMapSelection');
                        },
                        'closeCallBack': function() {
                            Odigeo.trigger('aircraftmap_manager:closeSeatMap');
                        },
                    };

                    if (options && options.keepSeatmapOpen) {
                        Odigeo._.assign(callbacks, {
                            keepCallBack: function() {
                            },
                            removeCallBack: function() {
                                Odigeo.trigger('seatmap-selection-manager:resetSeatmapSelection');
                            },
                        });
                    }

                    widgets.nagManager().execute('showRemoveSeatsNags', callbacks);
                },
                onResetSeatmapSelection: function() {
                    asyncWidgets.seatMapSelectionManager().execute('resetSeatmapSelection');
                },
                onShowNoSeatsSelectedDialog: function() {
                    var callbacks = {
                        'keepCallBack': function() {
                            Odigeo.trigger('aircraftmap_manager:keepSeatMapSelection');
                        },
                        'closeCallBack': function() {
                            Odigeo.trigger('aircraftmap_manager:closeSeatMap');
                        },
                    };
                    widgets.nagManager().execute('showNoSeatsSelectedNags', callbacks);
                },
                onKeepSeatMapSelection: function() {
                    widgetLoader.get('aircraftMapManager').execute('onTapRetainSelection');
                },
                onRemoveSeatMapSelection: function() {
                    widgetLoader.get('aircraftMapManager').execute('onTapRemoveSelection');
                },
                onTapAircraftMapNavigateButton: function(flightDetails, step, aircraftOptions) {
                    Odigeo.requireWidget('seatmap-selection-manager', 'seatmap_selection_manager', function(widget) {
                        widget.execute('onTapNavigateButton', flightDetails, step, aircraftOptions);
                    });
                },
                onCloseAircraftMap: function() {
                    Odigeo.requireWidget('seatmap-selection-manager', 'seatmap_selection_manager', function(widget) {
                        widget.execute('onCloseAircraftMap');
                    });
                    this.onScrollToSeatMapSelection();
                },
                onFareSelectedInPaxPage() {
                    membershipService.then(({default: service}) => {
                        service.updatePriceSelectedInSession('prime');
                    });
                    asyncWidgets.getSidebar().execute('setIsUpdatedMembershipPrices', true);
                    asyncWidgets.getSidebar().execute('updatePriceMemberDisplayPrices', 'discount', true);
                    this.updateMembershipPrices($page.find('.details_manager_data').data('membershipdualdisplay'), true);
                    this.onMembershipRefreshWidgets('discount', true);
                    widgetLoader.get('passengersSidebar').execute('onUpdateDetailsPriceBreakdown');
                },
                onFareRemovedInPaxPage() {
                    $page.find('.details_manager_data').data('discountselected', false);
                    membershipService.then(({default: service}) => {
                        service.updatePriceSelectedInSession('standard');
                    });
                    asyncWidgets.getSidebar().execute('setIsUpdatedMembershipPrices', false);
                    asyncWidgets.getSidebar().execute('updatePriceMemberDisplayPrices', 'noDiscount', false);
                    this.updateMembershipPrices($page.find('.details_manager_data').data('membershipdualdisplay'), false);
                    this.onMembershipRefreshWidgets('noDiscount', false);
                    widgetLoader.get('passengersSidebar').execute('onUpdateDetailsPriceBreakdown');
                },
                onFareSelectedInDualDisplay() {
                    this.onEqualProminencePaxPageDiscoverRestOfThePage();
                    this.onFareSelectedInPaxPage();
                },
                onFareRemovedInDualDisplay() {
                    this.onEqualProminencePaxPageDiscoverRestOfThePage();
                    this.onFareRemovedInPaxPage();
                },
                onUpdateSeatSelectionFees: function() {
                    asyncWidgets.seatMapSelectionManager().execute('updateSeatSelectionFees');
                },
                onHideErrors: function() {
                    Odigeo.requireWidget('seatmap-selection-manager', 'seatmap_selection_manager', function(widget) {
                        widget.execute('onHideErrors');
                    });
                },
                onScrollToSeatMapSelection: function() {
                    var $seatMapSelection = $page.find('.seatmapselection');
                    $seatMapSelection.attr('data-scroll', 'true');
                    $html.animate({
                        scrollTop: ($seatMapSelection.offset().top - 20) + 'px',
                    }, 500, 'swing', Odigeo._.bind(function() {
                        $seatMapSelection.attr('data-scroll', 'false');
                    }, this));
                },
                onRemembermeLoginOk: function(data) {
                    widgetLoader.get('login').execute('loginOk', data);
                },

                onRemembermeLoginError: function(data) {
                    if (Odigeo._.isNull(Odigeo.Utils.readCookie('sso_remember_me'))) {
                        widgetLoader.get('login').execute('loginWithError', data);
                    } else {
                        _remembermeEventLauncher('showLoginError', data);
                    }
                },

                activateDpWaitingPage: function() {
                    asyncWidgets.dpWaitingPage().execute('activate');
                    setTabFocusEvent(false);
                },

                cleaningDpWaitingPage: function() {
                    $mainContainer.removeClass('od-process-dpwaiting');
                    $logo.removeClass('disabled');
                },

                hiddenPageOverDpWaitingPage: function() {
                    $mainContainer.addClass('od-process-dpwaiting');
                    $logo.addClass('disabled');
                },

                sendUserToDpResults: function(product, isIntermediatePage) {
                    if (isIntermediatePage) {
                        product === 'accommodation'
                            ? this.onRequestXsellAccommodationResults()
                            : Odigeo.Router.navigate('results');
                    } else {
                        const page = product === 'accommodation' ? 'dpresults_accommodation' : 'dpresults_flights';

                        Odigeo.Session.set('DynPackActiveProduct', product);
                        Odigeo.Router.navigate(page, {
                            params: deeplink,
                        });
                    }
                },

                showRemoveHotelNag: function(imgUrl) {
                    xsellUtils.showRemoveHotelNag(
                        imgUrl,
                        this.removeHotelFromRemoveHotelNag.bind(this),
                        this.changeHotelFromRemoveHotelNag.bind(this)
                    );
                    trackingUtils.trackEvent('trip_information', 'remove_hotel');
                },
                changeHotelFromRemoveHotelNag: function() {
                    this.removeHotelFromRemoveHotelNag(true);
                    trackingUtils.trackEvent('nags', 'remove_hotel_change');
                },
                removeHotelFromRemoveHotelNag: function(isChangeHotel) {
                    if (!isSidebarSummary) {
                        asyncWidgets.getSidebar().execute('disableRemoveHotel');
                    }
                    xsellUtils.removeHotelFromShoppingCart(isChangeHotel);
                    const $removeHotelNag = $('.remove_hotel_nag');
                    $removeHotelNag.find('.dialog_content_container').removeClass('odf-hidden');
                    $removeHotelNag.find('.dialog_footer, .dialog_post_footer').addClass('odf-hidden');
                },

                onSuccessDeleteHotelFromCart: function(isChangeHotel) {
                    Odigeo.Session.set('deletedHotelFromCart', 'true');
                    if (!isChangeHotel) {
                        window.location.reload();
                    } else {
                        window.history.back();
                    }
                },

                onErrorDeleteHotelFromCart: function() {
                    window.history.back();
                },

                onDpToggleAccommodationDetails: function(settings) {
                    widgets.accommodationDetails().execute('process', settings);
                },

                closeAccommodationDeTails: function() {
                    widgets.accommodationDetails().execute('closeDetails');
                },

                /** START OF BAGGAGES **/

                onNagManagerAddBaggages: function() {
                    const dedicatedBagWidgetId = '#ancillaries-component-bags';
                    Odigeo.Utils.scrollToElement($page.find(dedicatedBagWidgetId));
                },

                onNagManagerContinue: function() {
                    continueToPayment();
                },

                onEvenUpBaggageSelection: function() {
                    widgetLoader.get('bags').execute('executeChildMethod', 'evenUpSelection', () => {
                        validatePassengers();
                        continueToPayment();
                    });
                },

                /** END OF BAGGAGES **/

                onNagSubscriber: function(widget) {
                    widgets.nagManager().execute('subscribeWidget', widget);
                },

                onNotifyNagProductEnabled: function(productId, hasSeatMapEnabled) {
                    widgets.nagManager().execute('notifyNagProductEnabled', productId, hasSeatMapEnabled);
                },

                onPrimeMerchandisingBadgeDisplayed: function() {
                    asyncWidgets.getDetailsManager().execute('showPrimeMerchandisingBubble');
                },

                onGoToSeats: function() {
                    Odigeo.Utils.scrollToElement($seatMapSelectionContainer);
                },

                onRemoveBackgroundHeaderSearchSummary: function() {
                    $backgroundDetailSearchSummary.removeClass('odf-hidden');
                },
                clearFareFamilySelection: function() {
                    const fareFamilies = Odigeo.Utils.parseJson(Odigeo.Session.get('fareFamiliesRequest'));
                    if (fareFamilies) {
                        delete fareFamilies.selected;
                        delete fareFamilies.fareFamilyAmount;
                        Odigeo.Session.set('fareFamiliesRequest', JSON.stringify(fareFamilies));
                    }
                },
                onAddPaxCompleteSuccessful: function() {
                    this.clearFareFamilySelection();
                    Odigeo.Router.reload();
                },
                onAddPaxCompleteError: function(optionParams) {
                    Odigeo.Router.navigate('results', {params: optionParams});
                },
                onMembershipSubscriptionRenewalChange: function(membershipPriceItem) {
                    this.onMembershipSubscriptionChange(membershipPriceItem);
                    if (membershipPriceItem.quantity === 0) {
                        widgetLoader.get('membershipRenewal').execute('deactivateMembership');
                    }
                },
                onMembershipSubscriptionChange: function(membershipPriceItem) {
                    if (Odigeo.Membership.isMembershipRenewalAtFirstBooking) {
                        asyncWidgets.getSidebar().execute('updatePricesWithMembershipSubscription', membershipPriceItem);
                        this.updateMembershipPrices(true, membershipPriceItem.quantity === 1,
                            membershipPriceItem.allPrice, membershipPriceItem.isPriceWithoutDiscountSelected);
                    } else {
                        asyncWidgets.getSidebar().execute('updatePricesWithMembershipSubscription', membershipPriceItem);
                        this.updateMembershipPrices(true, membershipPriceItem.quantity === 1 || membershipPriceItem.isUserLoggedIn,
                            membershipPriceItem.allPrice);
                    }
                    this.onTotalByFullPrice();
                },

                onOpenLoginForm: openLoginForm,

                continueButtonBinding: function() {
                    continueButtonBinding.call(this);
                },

                onContinueTransitionToPayment() {
                    websiteConfigCollection.getLoadedPromise().then(() => {
                        this.continueToPayment();
                    });
                },
                continueToPayment() {
                    trackingUtils.startMetric('LOAD_PAYMENTS_DESKTOP');
                    var saveData = $customersInfoSave.is(':checked');
                    const saveSmsConsent = $smsConsentSave.is(':checked');
                    var isUserLogged = $customerBuyerManager.hasClass('userLogged');
                    var $forms;
                    var seatsData;

                    Odigeo.trigger('session:stopped');

                    Odigeo.Session.set('sendSMSManageMyBookingsBuyerForm', saveSmsConsent);
                    if (saveSmsConsent === true) {
                        trackingUtils.trackEvent('sms_consent', `is_selected_${saveSmsConsent}`);
                    }

                    if (Odigeo.AB.isConsentRequest) {
                        const unsubcribeToNewslettter = $newslettterSubscription.is(':checked');
                        const gdprNewsletterEvent = unsubcribeToNewslettter ? 'onClickNewsletterUnsubscription' : 'onClickNewsletterSubscription';

                        widgets.gdprNewsletter().execute(gdprNewsletterEvent, false);
                    }

                    const suscribeToNewsletterToken = Odigeo.Session.get('changeNewsletterSubscriptionToken') || 'S';

                    if (Odigeo.AB.isNewNewsletterLogic && suscribeToNewsletterToken === 'S') {
                        widgets.gdprNewsletter().execute('setNewsletterEmail', widgetsData.buyer.mail);
                        widgets.gdprNewsletter().execute('suscribeToNewsletter');

                        Odigeo.requireWidget('passengers0', 'passengers_manager', function(passengersManager) {
                            passengersManager.execute('crmSubscription', widgetsData.buyer.mail);
                        });
                    }

                    if (Odigeo.AB.isUnsubscribeNewsletter && suscribeToNewsletterToken === 'U') {
                        widgets.gdprNewsletter().execute('setNewsletterEmail', widgetsData.buyer.mail);
                        const url = window.location.href || '';
                        widgets.gdprNewsletter().execute('setUnsubscribeFromUrl', url);
                        widgets.gdprNewsletter().execute('unsubscribeToNewsletter');
                    }

                    $forms = $('#details').find('form');
                    seatsData = combineSeats();

                    for (var i = 0; i < $forms.length; i++) {
                        var $form = $forms[i];
                        var $submit = document.createElement('input');
                        $submit.style.display = 'none';
                        $submit.type = 'submit';
                        $form.appendChild($submit);
                        $form.action = 'javascript:void(0)';
                        $form.target = 'iframe_native_autocomplete';
                        $submit.click();
                    }
                    widgetsData = !Odigeo._.isEmpty(seatsData) ? Odigeo._.extend(widgetsData, {seats: seatsData}) : widgetsData;

                    Odigeo._.extend(widgetsData, {
                        insurancesToAdd: [],
                        boardingOptions: boardingOptionsCollection.getCompleteUserSelectionData(),
                    });

                    shoppingCartProducts.bookingID = getBookingId();
                    shoppingCartProducts.data = widgetsData;
                    shoppingCartProducts.nextPage = 'PAYMENT_PAGE';
                    shoppingCartProducts.pageToGo = 'PAYMENT_PAGE';

                    if (Odigeo.AB.isFarePlusProgressiveDisclosureDesktop
                        || Odigeo.AB.isFarePlusProgressiveDisclosureMetaDesktop
                        || Odigeo.AB.isFarePlusUpdateShoppingCartAtSelection) {
                        ShoppingCart.commitIfNeeded({priceBreakdownCalculationMode: PBD_MODE})
                            .catch((err) => logger.error(err, 'Error committing products before addPersonalInfo'));
                    }

                    seatMapSelectionCollection.setPerksFromDapi();
                    widgetLoader.get('aircraftMapManager').execute('updateShoppingCart');
                    const submitProducts = (shoppingcartManager) =>
                        shoppingcartManager.execute('addProductToShoppingCart', shoppingCartProducts).execute('submitProducts');
                    Odigeo.requireWidget('shoppingcart-manager', 'shoppingcartmanager', (shoppingcartManager) => {
                        this.commitFromShoppingCart(widgetsData)
                            .then(() => submitProducts(shoppingcartManager))
                            .catch(() => submitProducts(shoppingcartManager));
                    });

                    ancillariesGeneric.trackAncillariesContinueFromPax();
                    baggageTracking.trackBaggagePaxContinuance();
                    seatsTracking.trackSeatsContinuance('pax');

                    trackCustomersInfo();
                    const shoppingCart = getStore().shoppingCart.shoppingCart;
                    const segments = (shoppingCart && shoppingCart.segments) ? shoppingCart.segments : null;
                    const productName = segments ? Odigeo.Utils.getProductName(segments) : Odigeo.Session.get('productName');
                    if (productName !== 'xfaring') {
                        trackingUtils.trackEvent('continue_next_step', `continue_clicks_${productName}`);
                    }

                    if (!isDynpack) {
                        Odigeo.UIElements.enhanceLoading($('.waiting_page'))
                            .showLoading([
                                'waiting_payment',
                                'waiting_bottom',
                                'waiting_pay_one',
                                'waiting_pay_two',
                                'waiting_pay_three',
                                'waiting_bottom_gradient',
                            ]);
                    } else {
                        asyncWidgets.dpWaitingPage().execute('activate', {redirect: 'payment'});
                        Odigeo.Session.set('before-page', 'tap-details');
                        setTabFocusEvent(false);
                    }

                    if (isUserLogged && saveData) {
                        _passengerEventLauncher('getTravellersData', 'addTravellerData');
                        _buyerEventLauncher('getContactDetails', 'addTravellerData');
                    }
                    _buyerEventLauncher('storeLocalData', !isUserLogged && saveData);
                    _passengerEventLauncher('storeLocalData', !isUserLogged && saveData);

                    widgets.nagManager().execute('saveNagsStateToSession');
                    asyncWidgets.getWaitings().execute('initFlexibilityDisruptionWaiting');

                    asyncWidgets.getBoardingOptions().execute('trackContinueToPayment');

                    Odigeo.preloadNextWidgetTemplates();
                },

                commitFromShoppingCart({buyer = {}}) {
                    ShoppingCart.setBuyerInfo(buyer);
                    if (!Odigeo.AB.isUpdatePersonalInfo) {
                        return ShoppingCart.commit({priceBreakdownCalculationMode: PBD_MODE});
                    } else {
                        return Promise.resolve();
                    }
                },

                onRegisterFullUserOk: function() {
                    Odigeo.trigger('continueTransitionToPayment');
                },
                onRecaptchaLoaded: function() {
                    Odigeo.requireWidget('rememberme', 'remember_me_manager', function(rememberMeManager) {
                        rememberMeManager.execute('renderCaptcha');
                    });
                    Odigeo._.each(['share-selection', 'share-selection-dp'], function(id) {
                        if (Odigeo.getWidgetByID(id)) {
                            Odigeo.requireWidget(id, 'share_selection', function(shareSelection) {
                                shareSelection.execute('renderCaptcha');
                            });
                        }
                    });
                },

                onShowSmartNagBaggage: function() {
                    var passengersData = [];
                    Odigeo._.each($passengerManagerArrayPassengers, function($passenger) {
                        Odigeo.requireWidget($passenger.id, 'passengers_manager', function(passenger) {
                            passengersData.push(passenger.get('getPassengerFullName', 'getPassengerFullName'));
                        });
                    });
                    widgets.smartNagBaggage().execute('setPassengersData', passengersData);
                    widgets.smartNagBaggage().execute('showSmartNagBaggage');
                },
                onUpdateSelectedBaggageFromSmartnag: function() {
                    validatePassengers();
                },
                onBoardingOptionSelected: function(data) {
                    asyncWidgets.getFlightSummary().execute('showBoardingOptions', data);
                    asyncWidgets.getHandBaggageSummary().execute('storeBoardingOptions', data);
                    boardingOptionsCollection.select(data);
                },
                onBoardingOptionSelectedOF2: function({selectedType}) {
                    asyncWidgets.getBoardingOptions().execute('onBoardingOptionSelectedOF2', selectedType);
                },
                onBoardingOptionInteracted: function() {
                    boardingOptionsCollection.setInteraction();
                },
                onShowPriorityBoardingNag: function() {
                    if (Odigeo.AB.isCabinBagsNagCompactDesktop) {
                        frontendShell.execute(({cabinBags}) => {
                            cabinBags.eventRequestHandler.execute(cabinBags.EVENTS.OPEN_NAG);
                        });
                    } else {
                        asyncWidgets.getBoardingOptions().execute('showNag');
                    }
                },
                onBoardingOptionsLoaded: function(data) {
                    asyncWidgets.getBoardingOptions().execute('loadData', data);
                    frontendShell.execute(({cabinBags}) => {
                        cabinBags.eventRequestHandler.execute(cabinBags.EVENTS.BOARDING_OPTIONS_LOADED);
                    });
                },
                onSetRefundableFareUpgradeShown() {
                    Odigeo.Session.set('isRefundableFareUpgradeShowInPax', true);
                    asyncWidgets.getShoppingCartManager().execute('setRefundableFareUpgradeShown');
                },
                onFareFamilySelected(fare) {
                    widgets.bookFlightManager().execute('bookFlightHandler', fare);
                },
                onShoppingCartCreated() {
                    Odigeo.Router.reload();
                },
                onShowFlightDetails() {
                    asyncWidgets.getFlightSummaryDetails().execute('toggleFlightDetails');
                },
                onOpenPriceBreakdown() {
                    widgetLoader.get('passengersSidebar').execute('renderPriceBreakdown');
                },
                onFareRuleSelect({data = {}} = {}) {
                    widgetLoader.get('fareRules').execute('onFareRuleSelect', data || {});

                    if (Odigeo.AB.isFareRulesProductHiding) {
                        asyncWidgets.getAncillariesModulePayment().execute('refresh');
                    }
                },
                onFareRuleSelectOF2({data = {}} = {}) {
                    widgetLoader.get('fareRules').execute('onFareRuleSelectOF2', data || {});
                },
                onFareRulesLoaded() {
                    widgetLoader.get('fareRules').execute('onFareRulesLoaded');
                    if (Odigeo.AB.isFarePlusProgressiveDisclosureDesktop || Odigeo.AB.isFarePlusProgressiveDisclosureMetaDesktop) {
                        Odigeo.trigger('widgetLoaded', 'fare_rules');
                    }
                },
                onFareRulesLoadedOF2() {
                    widgetLoader.get('fareRules').execute('onFareRulesLoaded', {sendPriceShellEvent: true});
                },
                onFrequentFlyerShown() {
                    if (!onLoadFreqFlyerTracked) {
                        const numFrequentFlyerShown = $page.find('.show_optional_requests').length;
                        trackingUtils.trackEvent('frequent_flyer_widget', 'onload_frequent_flyer_widget_pax:' + numFrequentFlyerShown);
                        onLoadFreqFlyerTracked = true;
                    }
                },
                onTrackCustomDimensionSidebar(priceOnlyFlightAmount) {
                    if (!customDimension54Tracked && readyForTrackingCustomDimension54) {
                        trackingUtils.trackPage('details-extras', {
                            legacy: Odigeo.Utils.getFunnelTrackingLegacy() + 'pasajeros-a/',
                            customDimensions: {
                                'transaction_price': '' + priceOnlyFlightAmount,
                            },
                        });
                        customDimension54Tracked = true;
                    }
                },
                onCabinBagsNagSelectionConfirmed(type) {
                    asyncWidgets.getBoardingOptions().execute('onNagBtnOptionOF2', type);
                },
                onCabinBagsNagLoadingError() {
                    asyncWidgets.getBoardingOptions().execute('onNagLoadingError');
                },
                onFastTrackToggle({selected, data}) {
                    const passengers = Odigeo._.filter($passengerManagerArray, function($passengerManager) {
                        return $passengerManager.id !== 'buyer';
                    });
                    ShoppingCart.builders.fastTrack
                        .id(data.type, data.id)
                        .data({
                            ...data,
                            price: {
                                total: data.price.total * passengers.length,
                            },
                        })
                        .from(ShoppingCart.sources.actions.USER_REQUESTED, ShoppingCart.sources.targets.WIDGET)
                        .toggle(selected);
                },
                onEqualProminencePaxPageDiscoverRestOfThePage() {
                    $page.find('.equal_prominence_buttons_on_pax_meta').removeClass('od-equal-prominence-meta');
                },
            }),
        });

    if (Odigeo.AB.isFareUpgradePaxEnabled) {
        widgetLoader.get('fareFamilies').execute('trackOpenFare');
    }
    if (Odigeo.AB.isFareUpgradePaxRenderable && !isDynpack && !isUpsell) {
        widgetLoader.get('fareFamilies').execute('getFareFamiliesFromSession');
    }

    if (Odigeo.AB.isAutomaticCheckinPaxDesktop) {
        asyncWidgets.getAncillariesModuleMain().execute('clearData').then(() => {
            asyncWidgets.getAncillariesModuleMain().execute('fetchData');
        });
    }

    if (Odigeo.AB.isSmsPaxPageDesktop) {
        asyncWidgets.getAncillariesModuleBeneathPhone().execute('clearData').then(() => {
            asyncWidgets.getAncillariesModuleBeneathPhone().execute('fetchData');
        });
    }

    const definefareUpgradeToShoppingCart = function(isSelected, name) {
        return {
            isSetup: false,
            added: isSelected,
            id: 'CANXSELF',
            name: name,
            type: 'CANX_INSURANCE',
        };
    };

    const addFareUpgradeToShoppingCart = function(fareUpgrade) {
        const action = fareUpgrade.added ? 'selectFareUpgrade' : 'deleteFareUpgrade';
        Odigeo.Session.set('isRefundableFareUpgradeSetInPax', fareUpgrade.added);
        asyncWidgets.getShoppingCartManager().execute(action);
    };

    priceManagerCollection.fetchData();

    var fixScrollingBehindModalLightbox = function(opened) {
        Odigeo.Device.getViewport().toggleClass('od-viewport-no-vertical-scroll', opened);
    };

    $window.resize(Odigeo._.bind(function() {
        Odigeo.requireWidget('seatmap-selection-manager', 'seatmap_selection_manager', function(widget) {
            widget.execute('onWindowResize');
        });
    }, this));

    if (isDynpack) {
        var actionWaitingPage = beforePage !== 'dpresults_accommodation_details' && !Odigeo._.isNull(beforePage) ? 'activate' : 'deactivate';

        asyncWidgets.dpWaitingPage().execute(actionWaitingPage);
        Odigeo.Session.set('hasUserSelectedFlight', true);
    } else if (Odigeo.Session.get('page') === 'payment') {
        Odigeo.UIElements.enhanceLoading($('.waiting_page')).hideLoading();
    } else {
        $mainContainer.removeClass('od-process-dpwaiting');
    }

    if (isDynpack) {
        Odigeo.Session.set('before-page', PAGE);
    }
    Odigeo.Session.set('page', PAGE);
    Odigeo.Router.eventController.execute();

    var $header = $('#header');
    var $details = $('#page');
    var $oneLineSearchBg = $header.find('.search_summary_bg');
    var hasErrors = false;
    var avoidNags = false;
    var showNagsAndContinueToPayment;
    var manageNagAndContinueToPayment;
    var $flightDetails = $page.find('.flight_details');
    var $backgroundDetailSearchSummary = $header.find('.background_detail_searchsummary');
    var detailsContinueButtonAction;
    var detailsContinueButtonActionGetData;
    var continueButtonBinding;
    var widgetsData = {};
    var shoppingCartProducts = {};
    var $passengerManagerArray = $page.find('div[data-widget="passengers_manager"]');
    var $passengerManagerArrayPassengers = Odigeo._.filter($passengerManagerArray, function($passengerManager) {
        return $passengerManager.id !== 'buyer';
    });
    var trackCustomersInfo;
    var trackingVirtualPage;
    var passengerSaveList = [];
    var contactDetailsData = {};
    var $customerBuyerManager = $page.find('.customers_buyer_manager');
    var $gdprIcon = $page.find('.gdpr_icon');
    var toggleGDPRinfo;
    var onGdprIconClick;
    var $customersInfoSave = $('#customersinfosave');
    const $smsConsentSave = $('#smsconsentsave');
    const $newslettterSubscription = $('#newsletttersubscription');
    var $detailsLogin = $page.find('.login_details');
    var seatSelectionData = {};
    var $popupPersuasiveBestPrice = $page.find('.persuasive_best_price');
    var $persuasionMessagePopup = $page.find('.persuasion_message_popup');
    var _passengerEventLauncher;
    var _collapsibleFlightSummaryLauncher;
    var _buyerEventLauncher;
    var _remembermeEventLauncher;
    var _submitUserResultRequest;
    var _activateLoggedElements;
    var combineSeats;
    var continueToPayment;
    var storeData = require('../modules/utils/storeData.utils');
    var changeTab = require('../modules/utils/tab_title.utils');
    var $seatMapSelectionContainer = $page.find('#seatmap-selection-manager');
    var isLegalCheckboxChecked;
    var showLegalCheckbox;
    var hideLegalCheckbox;
    var legalCheck;
    var validatePassengers;
    var closeAllBaggageSelectors;
    var isClickedOutsideWidget;
    var getListOfTravellers;
    var addMembership;
    var getPassengersData;
    var toggleContinueToPaymentBtn;
    var manageAddMembershipError;
    var solveAddMembershipError;
    var restoreFieldsFromPassengersData;
    var hideLuggageWidgetForTrains;

    var clearNagsSessionData;
    var isMemberInTravellers = false;
    var $continueButton = $page.find('.details_continue_button');

    const disclosureStepButtonBinding = () => {
        const $bagsSeatsDisclosureButton = $page.find('.bags_seats_progressive_disclosure');
        const step = $bagsSeatsDisclosureButton.data('disclosure-step');
        $bagsSeatsDisclosureButton.off(Odigeo.Events.tap).one(Odigeo.Events.tap, onDisclosureButtonClick.bind(this, step));
    };
    const onDisclosureButtonClick = (step) => {
        const formsValidationPromise = new Promise((resolve, reject) => {
            hasErrors = false;
            validatePassengers();
            // Dirty hack as in detailsContinueButtonAction to defer the hasError evaluation due to twisted events chain
            setTimeout(() => hasErrors ? reject() : resolve(), 400);
        });
        const farePlusValidationPromise = () => {
            const farePlusWidgetPromise = widgetLoader.get('fareRules');
            return farePlusWidgetPromise.get('hasErrors').then((hasErrors) => {
                if (hasErrors) {
                    farePlusWidgetPromise.execute('showFareRulesErrors', $html);
                    throw hasErrors;
                }
            });
        };
        formsValidationPromise
            .then(farePlusValidationPromise)
            .then(() => asyncWidgets.getDetailsManager().execute('emulateDisclosureStepEvent', step))
            .then(() => widgetLoader.get('aircraftMapManager').execute('autoScrollFirstSection'))
            .catch(disclosureStepButtonBinding);
    };

    if (Odigeo.Session.get('sendSMSManageMyBookingsBuyerForm') === 'true') {
        $smsConsentSave.prop('checked', true);
    }


    if ((!Odigeo.AB.isDpSearchInSecure || !Dynpack.isPreparedToLaunchSearchInSecure()) && Dynpack.hasToRedirectFromSecure()) {
        Odigeo.Router.navigate('dpresults_flights', {
            params: Odigeo._.last(Odigeo.History.getFragment().concat(';landingPageType=PASSENGER').split('/')),
        });
        return;
    }

    storeData.removeStorageOnNotSelected($customersInfoSave, 'passengersData');

    if (!Odigeo.AB.isTicketsLeftNextToContinueDetails) {
        stickySeatsLeftUtils.stickyTopSeats($page.find('.seats_left_top_details'), 'seatsLeftTopStickyDetails');
    }

    addMembership = function() {
        var data = widgets.getMembershipSubscription().get('getData');
        Odigeo._.extend(data, {email: widgetsData.buyer.mail});
        asyncWidgets.getMembershipManager().execute('addMembership', data);
        toggleContinueToPaymentBtn(true);
    };

    const addRenewalMembership = function() {
        widgetLoader.get('membershipRenewal').get('getRequestData')
            .then((requestData) => {
                const payload = Odigeo._.extend(
                    getPassengersData({email: widgetsData.buyer.mail}),
                    requestData,
                );
                asyncWidgets.getMembershipManager().execute('addMembership', payload);
                toggleContinueToPaymentBtn(true);
            });
    };

    getPassengersData = function(requestData) {
        return {
            email: requestData.email,
            password: requestData.password,
            name: widgetsData['passengers0'].name,
            lastName: widgetsData['passengers0'].firstLastName,
            quantity: requestData.quantity,
        };
    };

    toggleContinueToPaymentBtn = function(isBtnDisabled) {
        $page.find('.details_continue_button').attr('disabled', isBtnDisabled);
    };

    toggleContinueToPaymentBtn(false);

    solveAddMembershipError = function(error) {
        widgets.getMembershipSubscription().execute('solveAddMembershipError', this, error);
        continueButtonBinding();
    };

    manageAddMembershipError = function(error) {
        Odigeo.UIElements.showLightboxWarning('od-passenger-lightbox-logout',
            Odigeo._.bind(solveAddMembershipError, error), null,
            error.code === 'UNL_CONNECTION_FAILED' ?
                Odigeo.UIElements.translations.errMembershipSubscription.creatingAccount :
                Odigeo.UIElements.translations.errMembershipSubscription.memberExists);
    };

    _submitUserResultRequest = function(action, data) {
        Odigeo.requireWidget('users-manager', 'usersmanager', function(usersmanager) {
            usersmanager.execute(action, data);
        });
    };

    _activateLoggedElements = function(userDTO, hasTracking) {
        user = userDTO;
        $detailsLogin.addClass('hidden');
        $customerBuyerManager.addClass('userLogged').removeClass('localStorageEnabled');
        _submitUserResultRequest('mixUserAndMember', userDTO);
        _passengerEventLauncher('userLoggedShowPassengerList', {userDTO: userDTO, track: hasTracking});
        _remembermeEventLauncher('enableRememberMe', false);
        _buyerEventLauncher('userLoggedSetBuyerData', userDTO);
        _passengerEventLauncher('updatePassengerSelected');
        widgets.getMembershipSubscription().execute('loginDone', userDTO);
        widgets.nagManager().execute('loginDone');
        widgetLoader.get('membershipInfoLightbox').execute('loginDone');
        const membershipDTO = Odigeo._.get(userDTO, 'membershipInfoDTO.membershipDTO', null);
        if (isMembershipStatusActivated(membershipDTO) && !Odigeo._.isEmpty(userDTO.membershipInfoDTO.errorDTOs)) {
            var errorDTO = Odigeo._.head(userDTO.membershipInfoDTO.errorDTOs);
            var isPerksUsageExceeded = !Odigeo._.isUndefined(errorDTO.code) && errorDTO.code === 'UNL_VELOCITY_RULES_EXCEDEED';
            var primeName = userDTO.membershipInfoDTO.membershipDTO.name;
            widgets.nagManager().execute('updatePrimeUserBlocked', isPerksUsageExceeded, primeName);
        }
        readyForTrackingCustomDimension54 = true;
    };

    _passengerEventLauncher = function(event, data) {
        Odigeo._.each($passengerManagerArrayPassengers, function($passenger) {
            Odigeo.requireWidget($passenger.id, 'passengers_manager', function(passenger) {
                passenger.execute(event, (data ? data : null));
            });
        });
    };

    _collapsibleFlightSummaryLauncher = function(event, data) {
        Odigeo.requireWidget('collapsible-flight-summary', 'collapsible_flight_summary', function(flightSummary) {
            flightSummary.execute(event, data);
        });
    };

    getListOfTravellers = function() {
        let travellers = [];
        Odigeo._.each(widgetsData, function(passenger, index) {
            if (passenger && passenger.name && passenger.travellerType === 'ADULT') {
                travellers.push({name: passenger.name, lastName: passenger.firstLastName, id: index});
            }
        });
        return {travellers: travellers, email: widgetsData.buyer.mail};
    };

    _buyerEventLauncher = function(event, data) {
        Odigeo.requireWidget('buyer', 'passengers_manager', function(buyer) {
            buyer.execute(event, (data ? data : null));
        });
    };

    _remembermeEventLauncher = function(event, data) {
        Odigeo.requireWidget('rememberme', 'remember_me_manager', function(rememberme) {
            rememberme.execute(event, data);
        });
    };

    restoreFieldsFromPassengersData = function() {
        _passengerEventLauncher('userNotLoggedHidePassengerList');
        _buyerEventLauncher('userNotLoggedHideNonEditableBuyerLayer');
    };

    hideLuggageWidgetForTrains = function() {
        const shoppingCart = getStore().shoppingCart.shoppingCart;
        const segments = (shoppingCart && shoppingCart.segments) ? shoppingCart.segments : null;
        const allTrain = segments && segments.every((segment) => {
            return segment.transportType === 'TRAIN';
        });
        if (allTrain) {
            $page.find('#ancillaries-component-bags').addClass('odf-hidden');
        }
    };

    Odigeo.trigger('session:refreshed');

    if (Odigeo.AB.isFixRestorePaxPage && Odigeo.Session.storage.lastRouteChange) {
        asyncWidgets.getUsersManager().execute('submitUserRequest', {data: '', action: 'isLoggedIn'});
    }

    if (Odigeo.AB.isRailsLuggageAllowance) {
        hideLuggageWidgetForTrains();
    }

    if ($flightDetails.hasClass('hidden')) {
        Odigeo.UIElements.hideAllDialogs();
        $flightDetails.removeClass('hidden');
    }

    $('#details_infofooter_details_button', $page)
        .off(Odigeo.Events.tap)
        .on(Odigeo.Events.tap, function() {
            $('#details_infofooter_details', $page).toggleClass('hidden');
        });

    toggleGDPRinfo = function(e) {
        var $target = $(e.target);
        var gdrPopUpClass = '.gdpr_popup';
        var isGdprIcon = $target.hasClass('od-gdpr-icon');

        var $gdprPopup = (isGdprIcon) ? $target.parent().find(gdrPopUpClass) : $page.find(gdrPopUpClass);

        var isClosed = !$gdprPopup.hasClass('open');
        if (isGdprIcon && isClosed) {
            trackingUtils.trackEvent('sso_pax_page', 'save_paxsnbuyers_details');
        }

        $gdprPopup.toggleClass('open opened', (isGdprIcon) ? isClosed : false);
        e.stopPropagation();
    };

    onGdprIconClick = function(e) {
        toggleGDPRinfo(e);
        $page.one(Odigeo.Events.click, toggleGDPRinfo);
        $page.find('.dropdown_select_with_input').removeClass('focus');
    };

    $gdprIcon.on(Odigeo.Events.click, onGdprIconClick);

    clearNagsSessionData = function() {
        Odigeo.Session.storage.removeItem('nagsState');
    };

    combineSeats = function() {
        return Odigeo._.extend(seatSelectionData, handlerUtils.seatMapSelectionData);
    };

    const closeNotificationOnPageChange = () => {
        if (Odigeo.SessionScope.isMeta && notificationsService.isEnabled() &&
            notificationsService.getPermission() !== 'granted') {
            Odigeo.requireWidget('browser-notification-popup', 'browser_notification_popup', function(notificationWidget) {
                notificationWidget.execute('endPopup');
            });
        }
    };

    const doBuyerThingsOnPassengerPageComplete = (data) => {
        const paxComplete = buyerUtils.onPassengerPageComplete(data, hasErrors, widgetsData, $page);
        hasErrors = paxComplete.hasErrors || hasErrors;
        widgetsData = paxComplete.widgetData;
    };

    continueToPayment = function() {
        const isMembershipRenewalAtFirstBooking = Odigeo.Membership.isMembershipRenewalAtFirstBooking;
        closeNotificationOnPageChange();
        if (Odigeo.AB.isNewWarningPopup) {
            $details.find('.ui_dialog_box.opened').trigger('dialog:closeOnNavigate');
        }
        if ($page.find('.membership_container').children().length > 0) {
            widgets.getMembershipSubscription().execute('setListOfTravellers', getListOfTravellers());
            addMembership();
        } else if (isMembershipRenewalAtFirstBooking && $page.find('.membership_renewal_container').children().length > 0) {
            addRenewalMembership();
        } else {
            if (!Odigeo._.isUndefined(user) && isUserDTOMember(user)) {
                trackingUtils.trackEvent('unlocked', 'prime_mem_continue_sub-log');
            }
            if (Odigeo.AB.isGoBackNativeMessage) {
                window.onbeforeunload = null;
            }
            Odigeo.trigger('continueTransitionToPayment');
        }
    };

    validatePassengers = Odigeo._.bind(buyerUtils.validatePassengersManager, this,
        $page.find(`[data-widget="passengers_manager"]`));

    isLegalCheckboxChecked = function() {
        legalCheck = $page.find('[id="details-pax-legalcheck"]');
        return legalCheck.length > 0 && !legalCheck.is(':checked');
    };

    showLegalCheckbox = function() {
        $page.find('[id="details-pax-legalcheck-notchecked"]').removeClass('hidden');
        $page.find('[id="details-pax-legalcheck"]').parent().find('label').addClass('od-checkbox-not-checked');
        trackingUtils.trackEvent('pax_details_error', 'accept_terms_error');
        legalCheck.focus();
    };

    hideLegalCheckbox = function() {
        $page.find('[id="details-pax-legalcheck-notchecked"]').addClass('hidden');
        $page.find('[id="details-pax-legalcheck"]').parent().find('label').removeClass('od-checkbox-not-checked');
    };

    const showFareRulesErrors = () => {
        continueButtonBinding();
        if (Odigeo.AB.isFarePlusInjectionOF2Desktop) {
            widgetLoader.get('fareRules').execute('showFareRulesErrorsOF2', $html);
        } else {
            widgetLoader.get('fareRules').execute('showFareRulesErrors', $html);
        }
    };

    const doNagAndContinueToPayment = () => {
        const fareFamiliesSelectedDisableNags = Odigeo.Utils.parseJson(Odigeo.Session.get('fareFamiliesSelectedDisableNags')) || false;
        if (avoidNags || fareFamiliesSelectedDisableNags) {
            continueToPayment();
        } else {
            showNagsAndContinueToPayment();
        }
    };

    const addDefaultFareAndContinue = () => {
        widgetLoader.get('fareRules').execute('addClassicFareRule');
        doNagAndContinueToPayment();
    };

    manageNagAndContinueToPayment = function() {
        widgetLoader.get('fareRules').get('hasErrors').then((hasErrors) => {
            return hasErrors
                ? showFareRulesErrors()
                : addDefaultFareAndContinue();
        });
    };

    showNagsAndContinueToPayment = function() {
        var hasNagsBeenShown = widgets.nagManager().execute('shootNags');
        if (!hasNagsBeenShown) {
            continueToPayment();
        }
    };

    const requestNagInformation = () => {
        const groupPromise = widgets.getMembershipSubscription().get('getGroup');
        const isSelectedPromise = widgets.getMembershipSubscription().get('isSelected');
        return Promise.all([widgetLoader.get('login').get('isMember'), groupPromise, isSelectedPromise]);
    };

    const updatePrimeNag = function() {
        requestNagInformation().then(([isMember, group, isSelected]) => {
            widgets.nagManager().execute('updateMembership', {
                isMember,
                group: +group,
                added: isSelected,
            });
        });
    };

    detailsContinueButtonActionGetData = function() {
        widgetLoader.get('login').get('isLogged').then((isUserLogged) => {
            detailsContinueButtonAction(isUserLogged);
        });
    };

    detailsContinueButtonAction = function(isUserLogged) {
        const {
            isMembershipProductEnabled,
            isMembershipFreeTrial,
        } = Odigeo.Membership;
        tagManagement.fireExternalEvent('qualtrics', 'clickon_continue_FL');
        $continueButton.attr('disabled', true);
        hasErrors = false;
        validatePassengers();
        if (!isUserLogged && isMembershipProductEnabled && !isMembershipFreeTrial) {
            updatePrimeNag();
        }
        if (isLegalCheckboxChecked()) {
            showLegalCheckbox();
            continueButtonBinding();
        } else {
            hideLegalCheckbox();
            Odigeo._.delay(Odigeo._.bind(function() {
                if (!hasErrors) {
                    if (isMemberInTravellers) {
                        trackingUtils.trackEvent('unlocked', 'subscriber_included_continue');
                    }
                    manageNagAndContinueToPayment();
                } else {
                    continueButtonBinding();
                    trackingUtils.trackEvent('continue_next_step', 'continue_clicks_FE_error');
                }
            }, this), 400);
        }
    };

    continueButtonBinding = function() {
        $continueButton.attr('disabled', false);
        $continueButton.off(Odigeo.Events.tap).one(Odigeo.Events.tap, (event) => {
            trackClickEvent(event);
            detailsContinueButtonActionGetData();
        });
    };

    continueButtonBinding();
    disclosureStepButtonBinding();

    if (Odigeo.Session.get('ipHotelReminderNagShown') === 'false' && Odigeo.AB.isHotelReminderNag) {
        asyncWidgets.getAccommodationSearchManager().execute('getAccommodationResults');
    }

    Odigeo._.each($page.find('[data-widget="passengers_manager"]'), function(el) {
        var $el = $(el);
        var residentSelector = $(el).find('select[data-name="localityCodeOfResidence"]');
        if (Odigeo.AB.isCobaltDesktopForms) {
            Odigeo.UIElements.enhanceDateWithCobaltSelects($el.find('input[data-name="dateOfBirth"]'), {yearLimit: 1910});
            Odigeo.UIElements.enhanceDateWithCobaltSelects($el.find('input[data-name="identificationExpirationDate"]'), {yearLimit: 2050});
        } else {
            Odigeo.UIElements.enhanceDateWithSelects($el.find('input[data-name="dateOfBirth"]'), {yearLimit: 1910});
            Odigeo.UIElements.enhanceDateWithSelects($el.find('input[data-name="identificationExpirationDate"]'), {yearLimit: 2050});
        }

        $el.find('.flyer_code_select').off().on('change', function(ev) {
            $el.find('.flyer_code_input').data({'carrier': ev.target.value});
        });

        var $wrapper = $('#details').find('.ffc_tooltip_btn');
        Odigeo.UIElements.hint.enhance(PAGE, $wrapper, {
            events: {
                hover: true,
            },
            closeOthers: false,
        });

        if (residentSelector.length > 0) {
            residentSelector.off().on('change', function(ev) {
                $el.find('input[data-name="localityNameOfResidence"]').val(ev.target[ev.target.selectedIndex].label);
            });
            residentSelector.val(residentSelector[0][residentSelector[0].selectedIndex].value);
            $el.find('input[data-name="localityNameOfResidence"]').val(residentSelector[0][residentSelector[0].selectedIndex].label);

            $el.find('select[data-name="identificationType"] option[value="NIF"]')
                .prop('selected', true).trigger('change');
        }
    });

    _passengerEventLauncher('defaultNifSelection');

    trackCustomersInfo = function() {
        if ($customersInfoSave.is(':checked')) {
            trackingUtils.trackEvent('sso_pax_page', 'save_paxsnbuyers_details');
        }
    };

    trackingVirtualPage = function() {
        trackingUtils.trackPage('details-extras', {
            legacy: Odigeo.Utils.getFunnelTrackingLegacy() + 'pasajeros-a/',
            funnel: true,
        });
        const totalPrice = detailsTotalPriceCalculator.getTotal().sumTotalPrice;
        tagManagement.updateAndExtendDatalayer(totalPrice ? {priceInfo: {
            product_total_price: totalPrice.toFixed(2),
        }} : {});
        tagManagement.observeTmsTotalPrice('details');
    };

    if (!Odigeo._.isEmpty($popupPersuasiveBestPrice)) {
        Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), $popupPersuasiveBestPrice, {
            events: {
                tap: true,
            },
        });
    }

    Odigeo._.each($persuasionMessagePopup, function(message) {
        var dataTracking = $(message).data('tracking');
        var trackingObject = dataTracking
            ? {
                type: 'trackEvent',
                data: {
                    action: dataTracking,
                    label: 'price_guaranty_more_info',
                },
            }
            : null;
        Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), message, {
            events: {tap: true},
            googleAnalyticsOnOpen: trackingObject,
        });
    });

    var $wrapper = $page.find('.resident_city');
    Odigeo.UIElements.hint.enhance(PAGE, $wrapper, {
        events: {
            tap: true,
        },
    });

    closeAllBaggageSelectors = function(el, wrapperClass) {
        var bagSelectors = $('#details').find(wrapperClass);
        $.each(bagSelectors, function(key, value) {
            if (!$(value).is(el) && $(value).has(el).length === 0) {
                $(value).addClass('odf-hidden');
            }
        });
    };

    isClickedOutsideWidget = function(el, widgetSelector) {
        return $(el).parents(widgetSelector).length === 0;
    };

    $('.details').on(Odigeo.Events.tap, function(e) {
        const $target = $(e.target);
        const clickedOutsideBaggagePopup = !$target.hasClass('baggage_selector_button') && !$target.hasClass('baggage_add_button');
        const clickedOutsideForceLoginPopup = isForceLoginPopupOpened && isClickedOutsideWidget(e.target, '.prime_in_payment_force_login');

        if (clickedOutsideBaggagePopup) {
            closeAllBaggageSelectors(e.target, '.new_baggage_type_wrapper');
        }
        if (clickedOutsideForceLoginPopup) {
            Odigeo.requireWidget('buyer', 'passengers_manager', function(passenger) {
                passenger.execute('closeForceLoginPopup');
            });
        }
        if ($target.hasClass('baggage_selector_button') || $target.hasClass('baggage_add_button')) {
            Odigeo.Session.set(CONS.INTENTION_TO_BUY_BAGS, true);
        } else if ($target.hasClass('aircraftmap_seat')) {
            Odigeo.Session.set(CONS.INTENTION_TO_BUY_SEATS, true);
        }
    });

    var validBookingId = +getBookingId() > 0;
    if (!validBookingId) {
        Odigeo.UIElements.showBackToHomeError();
    }

    clearNagsSessionData();

    var searchData = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
    if (Odigeo._.has(searchData, 'searchSegments')) {
        var transportType = $page.find('.flights_list_item').map(function() {
            return $(this).attr('data-transport-type');
        });
        Odigeo._.each(searchData.searchSegments, function(segment, index) {
            segment['transportType'] = transportType[index];
        });
    }
    Odigeo.Session.set('searchParameters', JSON.stringify(searchData));

    if (Odigeo.Session.get('deletedHotelFromCart') === 'true') {
        Odigeo.Session.remove('deletedHotelFromCart');
        asyncWidgets.getSidebar().execute('confirmHotelRemoved');
    }

    Odigeo.trigger('getTotalByFullprice');

    if (isSidebarSummary) {
        asyncWidgets.getSidebar().execute('updatePage', PAGE);
    }

    $('#bread-crumbs').find('.bread_crumbs_wrapper').removeClass('hidden');

    Odigeo.Utils.patchFormsForiOS8($page);

    trackingVirtualPage();

    if (isDynpack) {
        asyncWidgets.dpWaitingPage().execute('deactivate');
    }

    trackingUtils.bindEvents($page);
    setFocusEventWindowMultitab(getBookingId());

    Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), $('.flightsummary_layover_hint'), {
        events: {
            hover: true,
        },
    });

    searchController.restoreSearchParams();

    asyncWidgets.seatMapSelectionManager().execute('updateSelectedSeats');
    widgetLoader.get('aircraftMapManager');

    if (Odigeo.Membership.isMembershipRenewalAtFirstBooking) {
        widgetLoader.get('membershipRenewal');
    }

    changeTab.init('flights_pax_page');

    if (Odigeo.SessionScope.isMeta && notificationsService.isEnabled() && notificationsService.getPermission() !== 'granted') {
        Odigeo.requireWidget('browser-notification-popup', 'browser_notification_popup', function(notificationWidget) {
            notificationWidget.execute('launchPopup');
        });
    }

    if (handlerUtils.isLandingFromMetaPassengers()) {
        asyncWidgets.getMembershipPricesTracker().execute('trackMembershipPricesDiscount');
        trackingUtils.stopMetric('LOAD_META_PASSENGERS');
        Odigeo.Session.remove('LOAD_META_INTERMEDIATE');
    } else {
        trackingUtils.stopMetric('LOAD_PASSENGER_DESKTOP');
    }

    sessionManagement.refreshSession(getBookingId(), PAGE);

    Odigeo.Router.bindAnyRoute(() => {
        widgetLoader.get('membershipInfoLightbox').execute('closeMembershipPerksInfoLightbox');
    });

    widgetLoader.get('cartDebugger').execute('load');
    widgetLoader.get('ancillariesSummary').execute('load');
    widgetLoader.get('freeCancellation').execute('load');
    widgetLoader.get('passengersSidebar').execute('render');
    widgetLoader.get('residentDiscount').execute('initialize');
    widgetLoader.get('bags');

    if (boardingOptionsCollection.isLoaded()) {
        boardingOptionsCollection.triggerBoardingOptionsLoaded();
    }

    loadAtolWidgets(['atol-protected-pax-footer-tooltip']);

    ShoppingCart.setBookingId(getBookingId());

    if (Odigeo.AB.isFarePlusProgressiveDisclosureDesktop || Odigeo.AB.isFarePlusProgressiveDisclosureMetaDesktop) {
        fareRulesManager.hasFareRules()
            .then((hasFareRules) => {
                if (!hasFareRules) {
                    $('.od-skeleton-fare-rules-wrapper').addClass('hidden');
                    asyncWidgets.getDetailsManager().execute('disclosureNextPageStep', 'fare-plus');
                }
            })
            .catch(() => {
                $('.od-skeleton-fare-rules-wrapper').addClass('hidden');
                asyncWidgets.getDetailsManager().execute('disclosureNextPageStep', 'fare-plus');
            });
    }

    vinFlightsTracking.trackFlowOnLoad();

    const cheaperthereConfig = window.cheaperthere_config;

    if (cheaperthereConfig) {
        const interceptUrl = cheaperthereConfig.intercept_response_urls;
        const trackUrls = Array.isArray(interceptUrl) ? interceptUrl.join('-') : interceptUrl;
        trackingUtils.trackEvent(
            'cheaper_there_extension',
            'onload_cheaper_there_extension'
        );
        logger.message(`cheaperthereConfig urls: ${trackUrls}`);
    }
    if (Odigeo.AB.isGoBackNativeMessage) {
        window.onbeforeunload = function(event) {
            event.preventDefault();
            event.returnValue = '';
            trackingUtils.trackEvent('leaving-pax-pop-up', 'onload-leaving-pax-pop-up');
        };
    }
};

function setFocusEventWindowMultitab(bookingId) {
    if (Odigeo.AB.isDynpackDesktopMultiTab) {
        setTabFocusEvent(true, bookingId);
    }
}

function resetPrimeSubscription() {
    dispatch({type: actions.SET_PRIME_MEMBER_SELECTED, entry: {
        isSubscriptionAdded: false,
    }});
}

function setDPPricingUtils() {
    dispatch({type: actions.SET_IS_META, entry: Odigeo.SessionScope.isMeta});
    dispatch({type: actions.SET_CURRENT_PAGE, entry: Odigeo.History.getPageNameFromFragment()});
}
